export const dummyPatientData = [
  {
    id: 1,
    name: "Olivia Rhyne",
    last_login: "Mar 21, 2019, 3:30pm",
    status: "medium",
    physician: "Dr. John",
    phone: "(930)-910-9327",
  },
  {
    id: 2,
    name: "Ethan Smith",
    last_login: "Jan 15, 2022, 11:45am",
    status: "urgent",
    physician: "Dr. John",
    phone: "(930)-910-9327",
  },
  {
    id: 3,
    name: "Avery Patel",
    last_login: "Oct 10, 2021, 8:15pm",
    status: "urgent",
    physician: "Dr. John",
    phone: "(930)-910-9327",
  },
  {
    id: 4,
    name: "Isaac Kim",
    last_login: "May 7, 2020, 6:00am",
    status: "urgent",
    physician: "Dr. John",
    phone: "(930)-910-9327",
  },
  {
    id: 5,
    name: "Mia Johnson",
    last_login: "Dec 1, 2022, 10:30am",
    status: "urgent",
    physician: "Dr. John",
    phone: "(930)-910-9327",
  },
  {
    id: 6,
    name: "Caleb Nguyen",
    last_login: "Sep 4, 2021, 4:20pm",
    status: "urgent",
    physician: "Dr. John",
    phone: "(930)-910-9327",
  },
  {
    id: 7,
    name: "Sophia Chen",
    last_login: "Nov 17, 2022, 2:00pm",
    status: "urgent",
    physician: "Dr. John",
    phone: "(930)-910-9327",
  },
  {
    id: 8,
    name: "William Lee",
    last_login: "Feb 22, 2023, 7:00am",
    status: "urgent",
    physician: "Dr. John",
    phone: "(930)-910-9327",
  },
  {
    id: 9,
    name: "Emma Davis",
    last_login: "Aug 9, 2022, 9:45pm",
    status: "urgent",
    physician: "Dr. John",
    phone: "(930)-910-9327",
  },
  {
    id: 10,
    name: "Lucas Brown",
    last_login: "Jun 3, 2021, 12:15pm",
    status: "urgent",
    physician: "Dr. John",
    phone: "(930)-910-9327",
  },
];

export const patientAssessmentData = [
  {
    name: "PHQ-8",
    date: "Jan 23, 2023",
    score: 15,
    total: 21,
    label: "severe depression",
  },
  {
    name: "GAD-7",
    date: "Mar 12, 2022",
    score: 17,
    total: 21,
    label: "depression",
  },
  {
    name: "SCL-90-R",
    date: "Jun 15, 2021",
    score: 25,
    total: 36,
    label: "suicidal",
  },
  {
    name: "Social Determinants Of Health (SDOH)",
    date: "Aug 1, 2022",
    score: 32,
    total: 63,
    label: "moderate",
  },
  {
    name: "ASRS-5",
    date: "Oct 5, 2022",
    score: 16,
    total: 20,
    label: "severe depression",
  },
  {
    name: "ISEL",
    date: "Jan 30, 2023",
    score: 27,
    total: 40,
    label: "severe depression",
  },
  {
    name: "DASS-21",
    date: "Feb 15, 2023",
    score: 10,
    total: 63,
    label: "severe depression",
  },
  {
    name: "PCL-5",
    date: "Nov 20, 2021",
    score: 55,
    total: 80,
    label: "severe depression",
  },
  {
    name: "OCI-R",
    date: "Dec 7, 2022",
    score: 32,
    total: 84,
    label: "severe depression",
  },
  {
    name: "Y-BOCS",
    date: "Sep 9, 2022",
    score: 28,
    total: 40,
    label: "severe depression",
  },
];

export const dummySDOHResults = [
  {
    text: "Tobacco Use",
    risk: "high",
  },
  {
    text: "Alcohol Use",
    risk: "high",
  },
  {
    text: "Financial Resource Strain",
    risk: "high",
  },
  {
    text: "Stress",
    risk: "na",
  },

  {
    text: "Housing Stability",
    risk: "low",
  },
  {
    text: "Transportation Needs",
    risk: "low",
  },
];

export const dummyFullJournalEntry = `
Dear John,
I hope this message finds you well. I have been struggling to find the right words to express what I'm going through, but I felt it was important to let you know. Lately, I've been feeling overwhelmed by a persistent sadness and a sense of emptiness that seems to have taken control of my life.


It feels like I'm trapped in a never-ending cycle of negative thoughts and emotions, and it's becoming increasingly difficult to find joy in the things that once made me happy. My motivation has dwindled, and it's hard for me to focus on even the simplest tasks. I've been isolating myself from friends and family, as I don't want to burden them with my problems or bring them down with my mood.


Sleep has become elusive, and when I do manage to fall asleep, it's never restful. My appetite has changed as well, and I find myself either not wanting to eat at all or overeating to cope with my emotions. I've noticed that my self-esteem has taken a hit, and I often find myself consumed by feelings of guilt, worthlessness, and hopelessness.


I want to be honest with you and admit that I've had thoughts of self-harm and, at times, even contemplated ending my life. I know these thoughts are dangerous, and I'm scared of what I might do if I don't get help. I'm reaching out because I trust you and I hope that, together, we can work on finding a way out of this darkness.


Please let me know when we can schedule an appointment to discuss these issues further. I'm willing to do whatever it takes to get better, and I truly believe that your guidance and support will be invaluable in my journey towards healing.


Thank you for taking the time to read this, and for your understanding.



Sincerely,
Someone
`;

export const dummyJournalEntries = [
  {
    id: 1,
    date: "Jan 23, 2023",
    text: dummyFullJournalEntry,
    labels: ["depression", "suicidal"],
  },

  {
    id: 2,
    date: "Feb 5, 2023",
    text: "I feel like I'm stuck in a rut and can't find my way out. Nothing seems to excite me anymore, and I'm constantly tired and unmotivated.",
    labels: ["depression", "suicidal"],
  },

  {
    id: 3,
    date: "Mar 8, 2023",
    text: "I can't seem to shake off this constant feeling of sadness and hopelessness. I feel like I'm just going through the motions of life without any real purpose or joy.",
    labels: ["depression", "suicidal"],
  },

  {
    id: 4,
    date: "Apr 1, 2023",
    text: "I'm having trouble sleeping and my appetite has decreased significantly. I'm also feeling really irritable and easily agitated.",
    labels: ["depression", "insomnia", "suicidal"],
  },

  {
    id: 5,
    date: "Apr 8, 2023",
    text: "I don't see the point in anything anymore. I don't care about my job, my relationships, or anything else in my life. It's like I'm just waiting for something to happen.",
    labels: ["depression", "suicidal"],
  },

  {
    id: 6,
    date: "Apr 12, 2023",
    text: "I've been having thoughts of hurting myself lately. I don't know what to do or who to talk to.",
    labels: ["depression", "suicidal"],
  },

  {
    id: 7,
    date: "Apr 14, 2023",
    text: "I feel like I'm a burden to everyone around me. I don't want to bother anyone with my problems, so I just keep everything inside.",
    labels: ["depression", "suicidal"],
  },

  {
    id: 8,
    date: "Apr 18, 2023",
    text: "I'm struggling to get out of bed in the morning. Everything just feels so overwhelming and exhausting.",
    labels: ["depression", "suicidal"],
  },

  {
    id: 9,
    date: "Apr 22, 2023",
    text: "I'm starting to lose hope that things will ever get better. It feels like this is just how my life is going to be from now on.",
    labels: ["depression", "suicidal"],
  },

  {
    id: 10,
    date: "Apr 28, 2023",
    text: "I'm finding it hard to connect with anyone lately. It's like I'm just going through the motions of socializing without any real interest or enjoyment.",
    labels: ["depression", "suicidal"],
  },
];

export const dummyAssessmentData = [
  {
    name: "PHQ-9",
    status: "active",
    gap_days: 22,
  },
  {
    name: "GAD-7",
    status: "inactive",
    gap_days: 15,
  },
  {
    name: "DASS-21",
    status: "active",
    gap_days: 30,
  },
  {
    name: "CES-D",
    status: "inactive",
    gap_days: 42,
  },
  {
    name: "PSQI",
    status: "active",
    gap_days: 11,
  },
  {
    name: "OCI-R",
    status: "inactive",
    gap_days: 20,
  },
  {
    name: "PCL-5",
    status: "active",
    gap_days: 25,
  },
  {
    name: "BDI-II",
    status: "inactive",
    gap_days: 48,
  },
  {
    name: "ISI",
    status: "active",
    gap_days: 17,
  },
  {
    name: "BAI",
    status: "inactive",
    gap_days: 33,
  },
];

export const dummyAccordionData = [
  {
    id: 1,
    heading: "Registration / Onboarding",
    title: "What is Rose? Is Rose right for me?",
    text: "The Rose App is a patient-facing application that allows patients to take assigned assessments, log their moods, journal, interact with their provider and access relevant content suggested by Rose and assigned by their provider. Using a provider-facing, web-based dashboard, Rose synthesizes the patient entered data into a summary chart for providers. Rose allows you to get key insights on your patients in between visits, allowing you to maximize the time spent in session.",
  },
  {
    id: 2,
    heading: "Demonstrations / Walk-Through",
    title: "How do I sign up for Rose?",
    text: "To sign up for Rose, simply download the app from the App Store or Google Play and follow the on-screen instructions to create your account. You will need to provide some basic information such as your name, date of birth, and email address, and then you will be ready to start using Rose.",
  },
  {
    id: 3,
    heading: "Assessments",
    title: "What types of assessments are available on Rose?",
    text: "Rose offers a variety of assessments that can help you better understand your mental health and track your progress over time. These include assessments for depression, anxiety, bipolar disorder, PTSD, and more. Your provider may assign specific assessments to you based on your needs and treatment plan.",
  },
  {
    id: 4,
    heading: "Questionaires",
    title: "How do I take an assessment on Rose?",
    text: 'To take an assessment on Rose, simply open the app and navigate to the "Assessments" section. From there, you can select the assessment you want to take and follow the on-screen instructions. Be sure to answer all questions honestly and to the best of your ability to get the most accurate results.',
  },
  {
    id: 5,
    heading: "Mood tracking",
    title: "How do I log my mood on Rose?",
    text: 'To log your mood on Rose, simply open the app and navigate to the "Mood" section. From there, you can select your current mood and add any notes or comments you want to include. You can also view your mood history over time to identify patterns or trends.',
  },
  {
    id: 6,
    heading: "Journaling",
    title: "How do I journal on Rose?",
    text: 'To journal on Rose, simply open the app and navigate to the "Journal" section. From there, you can create a new entry and add any thoughts, feelings, or experiences you want to record. You can also view your journal history over time to reflect on your progress and growth.',
  },
  {
    id: 7,
    heading: "Provider communication",
    title: "How do I communicate with my provider on Rose?",
    text: 'To communicate with your provider on Rose, simply open the app and navigate to the "Messages" section. From there, you can send a message to your provider and receive responses in real-time. You can also view your message history to keep track of your conversations.',
  },
  {
    id: 8,
    heading: "Content library",
    title: "What types of content are available on Rose?",
    text: "Rose offers a variety of content that can help you better understand your mental health and learn new coping skills. This includes articles, videos, podcasts, and more. Your provider may assign specific content to you based on your needs and treatment plan.",
  },
  {
    id: 9,
    heading: "Content library",
    title: "How do I access content on Rose?",
    text: "To access content on Rose, simply open the app and navigate to the Content section. From there, you can browse through the available content and select the items you want to view. You can also save your favorite content for easy access later on.",
  },
  {
    id: 10,
    heading: "Data privacy and security",
    title: "Is my data secure on Rose?",
    text: "Yes, Rose takes data privacy and security very seriously. All user data is encrypted both in transit and at rest, and our servers are protected by industry-standard security measures. Additionally, Rose is fully compliant with HIPAA regulations to ensure the confidentiality of patient data.",
  },
];

export const dummyClinics = [
  { value: "Clinic X", label: "Clinic X" },
  { value: "Demo Clinic", label: "Demo Clinic" },
  { value: "Test Clinic", label: "Test Clinic" },
  { value: "HealthFirst Clinic", label: "HealthFirst Clinic" },
  { value: "Sunset Medical Center", label: "Sunset Medical Center" },
  { value: "Pine Grove Healthcare", label: "Pine Grove Healthcare" },
  {
    value: "City Center Family Practice",
    label: "City Center Family Practice",
  },
  {
    value: "Southside Medical Associates",
    label: "Southside Medical Associates",
  },
  { value: "Midtown Urgent Care", label: "Midtown Urgent Care" },
  { value: "Northwest Medical Group", label: "Northwest Medical Group" },
];

export const doctorOptions = [
  { value: "Dr. John Doe", label: "Dr. John Doe" },
  { value: "Sarah Williams", label: "Sarah Williams" },
  { value: "Dr. Emily Lee", label: "Dr. Emily Lee" },
  { value: "David Martinez", label: "David Martinez" },
  { value: "Dr. Jane Smith", label: "Dr. Jane Smith" },
  { value: "Michael Johnson", label: "Michael Johnson" },
  { value: "Dr. Samantha Kim", label: "Dr. Samantha Kim" },
  { value: "Linda Davis", label: "Linda Davis" },
  { value: "Dr. William Chen", label: "Dr. William Chen" },
  { value: "Alexandra Jones", label: "Alexandra Jones" },
];

export const BHIUpdates = [
  { value: "Normal", label: "Normal" },
  { value: "Anxious", label: "Anxious" },
  { value: "Sleep Deprived", label: "Sleep Deprived" },
  { value: "Suicidal", label: "Suicidal" },
  { value: "Depressed", label: "Depressed" },
];

export const notesOptions = [
  { value: "BHI", label: "BHI Notes" },
  { value: "Self Added Note", label: "Clinician Notes" },
  { value: "Billing", label: "Billing Notes" },
];
export const activitiesOptions = [ 
  { value: "initialIntake", label: "Initial intake" },
  { value: "enroll", label: "Enroll in registry" },
  { value: "assign", label: "Assessment assignment" },
  { value: "review", label: "Review Patient Progress and app activity" },
  { value: "psych", label: "Psychosocial Interventions" },
  { value: "consultWpcp", label: "Consultation with PCP" },
  { value: "consultWpsych", label: "Consultation with Psych" },
  { value: "reporting", label: "Reporting" },
  { value: "careCordination", label: "Care Coordination" },
  { value: "carePlan", label: "Care Plan Review" },
];

export const billingCodeOptions = [
  {
    value: "BHI - 99484 - General Behavioral Health Integration",
    label: "BHI - 99484 - General Behavioral Health Integration",
  },
  {
    value: "CoCM - 99492 - 70min Consult",
    label: "CoCM - 99492 - 70min Consult",
  },
  {
    value: "CoCM - 99493 - 60min Consult",
    label: "CoCM - 99493 - 60min Consult",
  },
  {
    value: "CoCM - 99494 - 30min additional Consult",
    label: "CoCM - 99494 - 30min additional Consult",
  },
];

export const healthIssuesOptions = [
  {
    label: "Mental disorders due to known physiological conditions (F01-F09)",
    value: "Mental disorders due to known physiological conditions (F01-F09)",
  },
  {
    label: "F0150 Vascular dementia without behavioral disturbance ",
    value: "F0150 Vascular dementia without behavioral disturbance ",
  },
  {
    label: "F0151 Vascular dementia with behavioral disturbance ",
    value: "F0151 Vascular dementia with behavioral disturbance ",
  },
  {
    label:
      "F0280 Dementia in other diseases classified elsewhere without behavioral disturbance ",
    value:
      "F0280 Dementia in other diseases classified elsewhere without behavioral disturbance ",
  },
  {
    label:
      "F0281 Dementia in other diseases classified elsewhere with behavioral disturbance ",
    value:
      "F0281 Dementia in other diseases classified elsewhere with behavioral disturbance ",
  },
  {
    label: "F0390 Unspecified dementia without behavioral disturbance ",
    value: "F0390 Unspecified dementia without behavioral disturbance ",
  },
  {
    label: "F0391 Unspecified dementia with behavioral disturbance ",
    value: "F0391 Unspecified dementia with behavioral disturbance ",
  },
  {
    label: "F04 Amnestic disorder due to known physiological condition ",
    value: "F04 Amnestic disorder due to known physiological condition ",
  },
  {
    label: "F05 Delirium due to known physiological condition ",
    value: "F05 Delirium due to known physiological condition ",
  },
  {
    label:
      "F060 Psychotic disorder with hallucinations due to known physiological condition ",
    value:
      "F060 Psychotic disorder with hallucinations due to known physiological condition ",
  },
  {
    label: "F061 Catatonic disorder due to known physiological condition ",
    value: "F061 Catatonic disorder due to known physiological condition ",
  },
  {
    label:
      "F062 Psychotic disorder with delusions due to known physiological condition ",
    value:
      "F062 Psychotic disorder with delusions due to known physiological condition ",
  },
  {
    label:
      "F0630 Mood disorder due to known physiological condition, unspecified ",
    value:
      "F0630 Mood disorder due to known physiological condition, unspecified ",
  },
  {
    label:
      "F0631 Mood disorder due to known physiological condition with depressive features ",
    value:
      "F0631 Mood disorder due to known physiological condition with depressive features ",
  },
  {
    label:
      "F0632 Mood disorder due to known physiological condition with major depressive-like episode F0633 Mood disorder due to known physiological condition with manic features ",
    value:
      "F0632 Mood disorder due to known physiological condition with major depressive-like episode F0633 Mood disorder due to known physiological condition with manic features ",
  },
  {
    label:
      "F0634 Mood disorder due to known physiological condition with mixed features ",
    value:
      "F0634 Mood disorder due to known physiological condition with mixed features ",
  },
  {
    label: "F064 Anxiety disorder due to known physiological condition ",
    value: "F064 Anxiety disorder due to known physiological condition ",
  },
  {
    label:
      "F068 Other specified mental disorders due to known physiological condition ",
    value:
      "F068 Other specified mental disorders due to known physiological condition ",
  },
  {
    label: "F070 Personality change due to known physiological condition ",
    value: "F070 Personality change due to known physiological condition ",
  },
  {
    label: "F0781 Postconcussional syndrome ",
    value: "F0781 Postconcussional syndrome ",
  },
  {
    label:
      "F0789 Other personality and behavioral disorders due to known physiological condition ",
    value:
      "F0789 Other personality and behavioral disorders due to known physiological condition ",
  },
  {
    label:
      "F079 Unspecified personality and behavioral disorder due to known physiological condition ",
    value:
      "F079 Unspecified personality and behavioral disorder due to known physiological condition ",
  },
  {
    label:
      "F09 Unspecified mental disorder due to known physiological condition ",
    value:
      "F09 Unspecified mental disorder due to known physiological condition ",
  },
  {
    label:
      "Mental and behavioral disorders due to psychoactive substance use (F10-F19)",
    value:
      "Mental and behavioral disorders due to psychoactive substance use (F10-F19)",
  },
  {
    label: "F1010 Alcohol abuse, uncomplicated ",
    value: "F1010 Alcohol abuse, uncomplicated ",
  },
  {
    label: "F10120 Alcohol abuse with intoxication, uncomplicated ",
    value: "F10120 Alcohol abuse with intoxication, uncomplicated ",
  },
  {
    label: "F10121 Alcohol abuse with intoxication delirium ",
    value: "F10121 Alcohol abuse with intoxication delirium ",
  },
  {
    label: "F10129 Alcohol abuse with intoxication, unspecified ",
    value: "F10129 Alcohol abuse with intoxication, unspecified ",
  },
  {
    label: "F1014 Alcohol abuse with alcohol-induced mood disorder ",
    value: "F1014 Alcohol abuse with alcohol-induced mood disorder ",
  },
  {
    label:
      "F10150 Alcohol abuse with alcohol-induced psychotic disorder with delusions ",
    value:
      "F10150 Alcohol abuse with alcohol-induced psychotic disorder with delusions ",
  },
  {
    label:
      "F10151 Alcohol abuse with alcohol-induced psychotic disorder with hallucinations ",
    value:
      "F10151 Alcohol abuse with alcohol-induced psychotic disorder with hallucinations ",
  },
  {
    label:
      "F10159 Alcohol abuse with alcohol-induced psychotic disorder, unspecified ",
    value:
      "F10159 Alcohol abuse with alcohol-induced psychotic disorder, unspecified ",
  },
  {
    label: "F10180 Alcohol abuse with alcohol-induced anxiety disorder ",
    value: "F10180 Alcohol abuse with alcohol-induced anxiety disorder ",
  },
  {
    label: "F10181 Alcohol abuse with alcohol-induced sexual dysfunction ",
    value: "F10181 Alcohol abuse with alcohol-induced sexual dysfunction ",
  },
  {
    label: "F10182 Alcohol abuse with alcohol-induced sleep disorder ",
    value: "F10182 Alcohol abuse with alcohol-induced sleep disorder ",
  },
  {
    label: "F10188 Alcohol abuse with other alcohol-induced disorder ",
    value: "F10188 Alcohol abuse with other alcohol-induced disorder ",
  },
  {
    label: "F1019 Alcohol abuse with unspecified alcohol-induced disorder ",
    value: "F1019 Alcohol abuse with unspecified alcohol-induced disorder ",
  },
  {
    label: "F1020 Alcohol dependence, uncomplicated ",
    value: "F1020 Alcohol dependence, uncomplicated ",
  },
  {
    label: "F1021 Alcohol dependence, in remission ",
    value: "F1021 Alcohol dependence, in remission ",
  },
  {
    label: "F10220 Alcohol dependence with intoxication, uncomplicated ",
    value: "F10220 Alcohol dependence with intoxication, uncomplicated ",
  },
  {
    label: "F10221 Alcohol dependence with intoxication delirium ",
    value: "F10221 Alcohol dependence with intoxication delirium ",
  },
  {
    label: "F10229 Alcohol dependence with intoxication, unspecified ",
    value: "F10229 Alcohol dependence with intoxication, unspecified ",
  },
  {
    label: "F10230 Alcohol dependence with withdrawal, uncomplicated ",
    value: "F10230 Alcohol dependence with withdrawal, uncomplicated ",
  },
  {
    label: "F10231 Alcohol dependence with withdrawal delirium ",
    value: "F10231 Alcohol dependence with withdrawal delirium ",
  },
  {
    label:
      "F10232 Alcohol dependence with withdrawal with perceptual disturbance ",
    value:
      "F10232 Alcohol dependence with withdrawal with perceptual disturbance ",
  },
  {
    label: "F10239 Alcohol dependence with withdrawal, unspecified ",
    value: "F10239 Alcohol dependence with withdrawal, unspecified ",
  },
  {
    label: "F1024 Alcohol dependence with alcohol-induced mood disorder ",
    value: "F1024 Alcohol dependence with alcohol-induced mood disorder ",
  },
  {
    label:
      "F10250 Alcohol dependence with alcohol-induced psychotic disorder with delusions ",
    value:
      "F10250 Alcohol dependence with alcohol-induced psychotic disorder with delusions ",
  },
  {
    label:
      "F10251 Alcohol dependence with alcohol-induced psychotic disorder with hallucinations ",
    value:
      "F10251 Alcohol dependence with alcohol-induced psychotic disorder with hallucinations ",
  },
  {
    label:
      "F10259 Alcohol dependence with alcohol-induced psychotic disorder, unspecified ",
    value:
      "F10259 Alcohol dependence with alcohol-induced psychotic disorder, unspecified ",
  },
  {
    label:
      "F1026 Alcohol dependence with alcohol-induced persisting amnestic disorder ",
    value:
      "F1026 Alcohol dependence with alcohol-induced persisting amnestic disorder ",
  },
  {
    label: "F1027 Alcohol dependence with alcohol-induced persisting dementia ",
    value: "F1027 Alcohol dependence with alcohol-induced persisting dementia ",
  },
  {
    label: "F10280 Alcohol dependence with alcohol-induced anxiety disorder ",
    value: "F10280 Alcohol dependence with alcohol-induced anxiety disorder ",
  },
  {
    label: "F10281 Alcohol dependence with alcohol-induced sexual dysfunction ",
    value: "F10281 Alcohol dependence with alcohol-induced sexual dysfunction ",
  },
  {
    label: "F10282 Alcohol dependence with alcohol-induced sleep disorder ",
    value: "F10282 Alcohol dependence with alcohol-induced sleep disorder ",
  },
  {
    label: "F10288 Alcohol dependence with other alcohol-induced disorder ",
    value: "F10288 Alcohol dependence with other alcohol-induced disorder ",
  },
  {
    label:
      "F1029 Alcohol dependence with unspecified alcohol-induced disorder ",
    value:
      "F1029 Alcohol dependence with unspecified alcohol-induced disorder ",
  },
  {
    label: "F10920 Alcohol use, unspecified with intoxication, uncomplicated ",
    value: "F10920 Alcohol use, unspecified with intoxication, uncomplicated ",
  },
  {
    label: "F10921 Alcohol use, unspecified with intoxication delirium ",
    value: "F10921 Alcohol use, unspecified with intoxication delirium ",
  },
  {
    label: "F10929 Alcohol use, unspecified with intoxication, unspecified ",
    value: "F10929 Alcohol use, unspecified with intoxication, unspecified ",
  },
  {
    label: "F1094 Alcohol use, unspecified with alcohol-induced mood disorder ",
    value: "F1094 Alcohol use, unspecified with alcohol-induced mood disorder ",
  },
  {
    label:
      "F10950 Alcohol use, unspecified with alcohol-induced psychotic disorder with delusions ",
    value:
      "F10950 Alcohol use, unspecified with alcohol-induced psychotic disorder with delusions ",
  },
  {
    label:
      "F10951 Alcohol use, unspecified with alcohol-induced psychotic disorder with hallucinations F10959 Alcohol use, unspecified with alcohol-induced psychotic disorder, unspecified ",
    value:
      "F10951 Alcohol use, unspecified with alcohol-induced psychotic disorder with hallucinations F10959 Alcohol use, unspecified with alcohol-induced psychotic disorder, unspecified ",
  },
  {
    label:
      "F1096 Alcohol use, unspecified with alcohol-induced persisting amnestic disorder ",
    value:
      "F1096 Alcohol use, unspecified with alcohol-induced persisting amnestic disorder ",
  },
  {
    label:
      "F1097 Alcohol use, unspecified with alcohol-induced persisting dementia ",
    value:
      "F1097 Alcohol use, unspecified with alcohol-induced persisting dementia ",
  },
  {
    label:
      "F10980 Alcohol use, unspecified with alcohol-induced anxiety disorder ",
    value:
      "F10980 Alcohol use, unspecified with alcohol-induced anxiety disorder ",
  },
  {
    label:
      "F10981 Alcohol use, unspecified with alcohol-induced sexual dysfunction ",
    value:
      "F10981 Alcohol use, unspecified with alcohol-induced sexual dysfunction ",
  },
  {
    label:
      "F10982 Alcohol use, unspecified with alcohol-induced sleep disorder ",
    value:
      "F10982 Alcohol use, unspecified with alcohol-induced sleep disorder ",
  },
  {
    label:
      "F10988 Alcohol use, unspecified with other alcohol-induced disorder ",
    value:
      "F10988 Alcohol use, unspecified with other alcohol-induced disorder ",
  },
  {
    label:
      "F1099 Alcohol use, unspecified with unspecified alcohol-induced disorder ",
    value:
      "F1099 Alcohol use, unspecified with unspecified alcohol-induced disorder ",
  },
  {
    label: "F1110 Opioid abuse, uncomplicated ",
    value: "F1110 Opioid abuse, uncomplicated ",
  },
  {
    label: "F11120 Opioid abuse with intoxication, uncomplicated ",
    value: "F11120 Opioid abuse with intoxication, uncomplicated ",
  },
  {
    label: "F11121 Opioid abuse with intoxication delirium ",
    value: "F11121 Opioid abuse with intoxication delirium ",
  },
  {
    label: "F11122 Opioid abuse with intoxication with perceptual disturbance ",
    value: "F11122 Opioid abuse with intoxication with perceptual disturbance ",
  },
  {
    label: "F11129 Opioid abuse with intoxication, unspecified ",
    value: "F11129 Opioid abuse with intoxication, unspecified ",
  },
  {
    label: "F1114 Opioid abuse with opioid-induced mood disorder ",
    value: "F1114 Opioid abuse with opioid-induced mood disorder ",
  },
  {
    label:
      "F11150 Opioid abuse with opioid-induced psychotic disorder with delusions ",
    value:
      "F11150 Opioid abuse with opioid-induced psychotic disorder with delusions ",
  },
  {
    label:
      "F11151 Opioid abuse with opioid-induced psychotic disorder with hallucinations ",
    value:
      "F11151 Opioid abuse with opioid-induced psychotic disorder with hallucinations ",
  },
  {
    label:
      "F11159 Opioid abuse with opioid-induced psychotic disorder, unspecified ",
    value:
      "F11159 Opioid abuse with opioid-induced psychotic disorder, unspecified ",
  },
  {
    label: "F11181 Opioid abuse with opioid-induced sexual dysfunction ",
    value: "F11181 Opioid abuse with opioid-induced sexual dysfunction ",
  },
  {
    label: "F11182 Opioid abuse with opioid-induced sleep disorder ",
    value: "F11182 Opioid abuse with opioid-induced sleep disorder ",
  },
  {
    label: "F11188 Opioid abuse with other opioid-induced disorder ",
    value: "F11188 Opioid abuse with other opioid-induced disorder ",
  },
  {
    label: "F1119 Opioid abuse with unspecified opioid-induced disorder ",
    value: "F1119 Opioid abuse with unspecified opioid-induced disorder ",
  },
  {
    label: "F1120 Opioid dependence, uncomplicated ",
    value: "F1120 Opioid dependence, uncomplicated ",
  },
  {
    label: "F1121 Opioid dependence, in remission ",
    value: "F1121 Opioid dependence, in remission ",
  },
  {
    label: "F11220 Opioid dependence with intoxication, uncomplicated ",
    value: "F11220 Opioid dependence with intoxication, uncomplicated ",
  },
  {
    label: "F11221 Opioid dependence with intoxication delirium ",
    value: "F11221 Opioid dependence with intoxication delirium ",
  },
  {
    label:
      "F11222 Opioid dependence with intoxication with perceptual disturbance ",
    value:
      "F11222 Opioid dependence with intoxication with perceptual disturbance ",
  },
  {
    label: "F11229 Opioid dependence with intoxication, unspecified ",
    value: "F11229 Opioid dependence with intoxication, unspecified ",
  },
  {
    label: "F1123 Opioid dependence with withdrawal ",
    value: "F1123 Opioid dependence with withdrawal ",
  },
  {
    label: "F1124 Opioid dependence with opioid-induced mood disorder ",
    value: "F1124 Opioid dependence with opioid-induced mood disorder ",
  },
  {
    label:
      "F11250 Opioid dependence with opioid-induced psychotic disorder with delusions ",
    value:
      "F11250 Opioid dependence with opioid-induced psychotic disorder with delusions ",
  },
  {
    label:
      "F11251 Opioid dependence with opioid-induced psychotic disorder with hallucinations ",
    value:
      "F11251 Opioid dependence with opioid-induced psychotic disorder with hallucinations ",
  },
  {
    label:
      "F11259 Opioid dependence with opioid-induced psychotic disorder, unspecified ",
    value:
      "F11259 Opioid dependence with opioid-induced psychotic disorder, unspecified ",
  },
  {
    label: "F11281 Opioid dependence with opioid-induced sexual dysfunction ",
    value: "F11281 Opioid dependence with opioid-induced sexual dysfunction ",
  },
  {
    label: "F11282 Opioid dependence with opioid-induced sleep disorder ",
    value: "F11282 Opioid dependence with opioid-induced sleep disorder ",
  },
  {
    label: "F11288 Opioid dependence with other opioid-induced disorder ",
    value: "F11288 Opioid dependence with other opioid-induced disorder ",
  },
  {
    label: "F1129 Opioid dependence with unspecified opioid-induced disorder ",
    value: "F1129 Opioid dependence with unspecified opioid-induced disorder ",
  },
  {
    label: "F1190 Opioid use, unspecified, uncomplicated ",
    value: "F1190 Opioid use, unspecified, uncomplicated ",
  },
  {
    label: "F11920 Opioid use, unspecified with intoxication, uncomplicated ",
    value: "F11920 Opioid use, unspecified with intoxication, uncomplicated ",
  },
  {
    label: "F11921 Opioid use, unspecified with intoxication delirium ",
    value: "F11921 Opioid use, unspecified with intoxication delirium ",
  },
  {
    label:
      "F11922 Opioid use, unspecified with intoxication with perceptual disturbance ",
    value:
      "F11922 Opioid use, unspecified with intoxication with perceptual disturbance ",
  },
  {
    label: "F11929 Opioid use, unspecified with intoxication, unspecified ",
    value: "F11929 Opioid use, unspecified with intoxication, unspecified ",
  },
  {
    label: "F1193 Opioid use, unspecified with withdrawal ",
    value: "F1193 Opioid use, unspecified with withdrawal ",
  },
  {
    label: "F1194 Opioid use, unspecified with opioid-induced mood disorder ",
    value: "F1194 Opioid use, unspecified with opioid-induced mood disorder ",
  },
  {
    label:
      "F11950 Opioid use, unspecified with opioid-induced psychotic disorder with delusions ",
    value:
      "F11950 Opioid use, unspecified with opioid-induced psychotic disorder with delusions ",
  },
  {
    label:
      "F11951 Opioid use, unspecified with opioid-induced psychotic disorder with hallucinations F11959 Opioid use, unspecified with opioid-induced psychotic disorder, unspecified ",
    value:
      "F11951 Opioid use, unspecified with opioid-induced psychotic disorder with hallucinations F11959 Opioid use, unspecified with opioid-induced psychotic disorder, unspecified ",
  },
  {
    label:
      "F11981 Opioid use, unspecified with opioid-induced sexual dysfunction",
    value:
      "F11981 Opioid use, unspecified with opioid-induced sexual dysfunction",
  },
  {
    label: "F11982 Opioid use, unspecified with opioid-induced sleep disorder ",
    value: "F11982 Opioid use, unspecified with opioid-induced sleep disorder ",
  },
  {
    label: "F11988 Opioid use, unspecified with other opioid-induced disorder ",
    value: "F11988 Opioid use, unspecified with other opioid-induced disorder ",
  },
  {
    label:
      "F1199 Opioid use, unspecified with unspecified opioid-induced disorder ",
    value:
      "F1199 Opioid use, unspecified with unspecified opioid-induced disorder ",
  },
  {
    label: "F1210 Cannabis abuse, uncomplicated ",
    value: "F1210 Cannabis abuse, uncomplicated ",
  },
  {
    label: "F12120 Cannabis abuse with intoxication, uncomplicated ",
    value: "F12120 Cannabis abuse with intoxication, uncomplicated ",
  },
  {
    label: "F12121 Cannabis abuse with intoxication delirium ",
    value: "F12121 Cannabis abuse with intoxication delirium ",
  },
  {
    label:
      "F12122 Cannabis abuse with intoxication with perceptual disturbance ",
    value:
      "F12122 Cannabis abuse with intoxication with perceptual disturbance ",
  },
  {
    label: "F12129 Cannabis abuse with intoxication, unspecified ",
    value: "F12129 Cannabis abuse with intoxication, unspecified ",
  },
  {
    label: "F12150 Cannabis abuse with psychotic disorder with delusions ",
    value: "F12150 Cannabis abuse with psychotic disorder with delusions ",
  },
  {
    label: "F12151 Cannabis abuse with psychotic disorder with hallucinations ",
    value: "F12151 Cannabis abuse with psychotic disorder with hallucinations ",
  },
  {
    label: "F12159 Cannabis abuse with psychotic disorder, unspecified ",
    value: "F12159 Cannabis abuse with psychotic disorder, unspecified ",
  },
  {
    label: "F12180 Cannabis abuse with cannabis-induced anxiety disorder ",
    value: "F12180 Cannabis abuse with cannabis-induced anxiety disorder ",
  },
  {
    label: "F12188 Cannabis abuse with other cannabis-induced disorder ",
    value: "F12188 Cannabis abuse with other cannabis-induced disorder ",
  },
  {
    label: "F1219 Cannabis abuse with unspecified cannabis-induced disorder ",
    value: "F1219 Cannabis abuse with unspecified cannabis-induced disorder ",
  },
  {
    label: "F1220 Cannabis dependence, uncomplicated ",
    value: "F1220 Cannabis dependence, uncomplicated ",
  },
  {
    label: "F1221 Cannabis dependence, in remission ",
    value: "F1221 Cannabis dependence, in remission ",
  },
  {
    label: "F12220 Cannabis dependence with intoxication, uncomplicated ",
    value: "F12220 Cannabis dependence with intoxication, uncomplicated ",
  },
  {
    label: "F12221 Cannabis dependence with intoxication delirium ",
    value: "F12221 Cannabis dependence with intoxication delirium ",
  },
  {
    label:
      "F12222 Cannabis dependence with intoxication with perceptual disturbance ",
    value:
      "F12222 Cannabis dependence with intoxication with perceptual disturbance ",
  },
  {
    label: "F12229 Cannabis dependence with intoxication, unspecified ",
    value: "F12229 Cannabis dependence with intoxication, unspecified ",
  },
  {
    label: "F12250 Cannabis dependence with psychotic disorder with delusions ",
    value: "F12250 Cannabis dependence with psychotic disorder with delusions ",
  },
  {
    label:
      "F12251 Cannabis dependence with psychotic disorder with hallucinations ",
    value:
      "F12251 Cannabis dependence with psychotic disorder with hallucinations ",
  },
  {
    label: "F12259 Cannabis dependence with psychotic disorder, unspecified ",
    value: "F12259 Cannabis dependence with psychotic disorder, unspecified ",
  },
  {
    label: "F12280 Cannabis dependence with cannabis-induced anxiety disorder ",
    value: "F12280 Cannabis dependence with cannabis-induced anxiety disorder ",
  },
  {
    label: "F12288 Cannabis dependence with other cannabis-induced disorder ",
    value: "F12288 Cannabis dependence with other cannabis-induced disorder ",
  },
  {
    label:
      "F1229 Cannabis dependence with unspecified cannabis-induced disorder ",
    value:
      "F1229 Cannabis dependence with unspecified cannabis-induced disorder ",
  },
  {
    label: "F1290 Cannabis use, unspecified, uncomplicated ",
    value: "F1290 Cannabis use, unspecified, uncomplicated ",
  },
  {
    label: "F12920 Cannabis use, unspecified with intoxication, uncomplicated ",
    value: "F12920 Cannabis use, unspecified with intoxication, uncomplicated ",
  },
  {
    label: "F12921 Cannabis use, unspecified with intoxication delirium ",
    value: "F12921 Cannabis use, unspecified with intoxication delirium ",
  },
  {
    label:
      "F12922 Cannabis use, unspecified with intoxication with perceptual disturbance ",
    value:
      "F12922 Cannabis use, unspecified with intoxication with perceptual disturbance ",
  },
  {
    label: "F12929 Cannabis use, unspecified with intoxication, unspecified ",
    value: "F12929 Cannabis use, unspecified with intoxication, unspecified ",
  },
  {
    label:
      "F12950 Cannabis use, unspecified with psychotic disorder with delusions ",
    value:
      "F12950 Cannabis use, unspecified with psychotic disorder with delusions ",
  },
  {
    label:
      "F12951 Cannabis use, unspecified with psychotic disorder with hallucinations ",
    value:
      "F12951 Cannabis use, unspecified with psychotic disorder with hallucinations ",
  },
  {
    label:
      "F12959 Cannabis use, unspecified with psychotic disorder, unspecified ",
    value:
      "F12959 Cannabis use, unspecified with psychotic disorder, unspecified ",
  },
  {
    label: "F12980 Cannabis use, unspecified with anxiety disorder ",
    value: "F12980 Cannabis use, unspecified with anxiety disorder ",
  },
  {
    label:
      "F12988 Cannabis use, unspecified with other cannabis-induced disorder ",
    value:
      "F12988 Cannabis use, unspecified with other cannabis-induced disorder ",
  },
  {
    label:
      "F1299 Cannabis use, unspecified with unspecified cannabis-induced disorder ",
    value:
      "F1299 Cannabis use, unspecified with unspecified cannabis-induced disorder ",
  },
  {
    label: "F1310 Sedative, hypnotic or anxiolytic abuse, uncomplicated ",
    value: "F1310 Sedative, hypnotic or anxiolytic abuse, uncomplicated ",
  },
  {
    label:
      "F13120 Sedative, hypnotic or anxiolytic abuse with intoxication, uncomplicated ",
    value:
      "F13120 Sedative, hypnotic or anxiolytic abuse with intoxication, uncomplicated ",
  },
  {
    label:
      "F13121 Sedative, hypnotic or anxiolytic abuse with intoxication delirium ",
    value:
      "F13121 Sedative, hypnotic or anxiolytic abuse with intoxication delirium ",
  },
  {
    label:
      "F13129 Sedative, hypnotic or anxiolytic abuse with intoxication, unspecified ",
    value:
      "F13129 Sedative, hypnotic or anxiolytic abuse with intoxication, unspecified ",
  },
  {
    label:
      "F1314 Sedative, hypnotic or anxiolytic abuse with sedative, hypnotic or anxiolytic-induced mood disorder ",
    value:
      "F1314 Sedative, hypnotic or anxiolytic abuse with sedative, hypnotic or anxiolytic-induced mood disorder ",
  },
  {
    label:
      "F13150 Sedative, hypnotic or anxiolytic abuse with sedative, hypnotic or anxiolytic-induced psychotic disorder with delusions ",
    value:
      "F13150 Sedative, hypnotic or anxiolytic abuse with sedative, hypnotic or anxiolytic-induced psychotic disorder with delusions ",
  },
  {
    label:
      "F13151 Sedative, hypnotic or anxiolytic abuse with sedative, hypnotic or anxiolytic-induced psychotic disorder with hallucinations ",
    value:
      "F13151 Sedative, hypnotic or anxiolytic abuse with sedative, hypnotic or anxiolytic-induced psychotic disorder with hallucinations ",
  },
  {
    label:
      "F13159 Sedative, hypnotic or anxiolytic abuse with sedative, hypnotic or anxiolytic-induced psychotic disorder, unspecified ",
    value:
      "F13159 Sedative, hypnotic or anxiolytic abuse with sedative, hypnotic or anxiolytic-induced psychotic disorder, unspecified ",
  },
  {
    label:
      "F13180 Sedative, hypnotic or anxiolytic abuse with sedative, hypnotic or anxiolytic-induced anxiety disorder",
    value:
      "F13180 Sedative, hypnotic or anxiolytic abuse with sedative, hypnotic or anxiolytic-induced anxiety disorder",
  },
  {
    label:
      "F13181 Sedative, hypnotic or anxiolytic abuse with sedative, hypnotic or anxiolytic-induced sexual dysfunction ",
    value:
      "F13181 Sedative, hypnotic or anxiolytic abuse with sedative, hypnotic or anxiolytic-induced sexual dysfunction ",
  },
  {
    label:
      "F13182 Sedative, hypnotic or anxiolytic abuse with sedative, hypnotic or anxiolytic-induced sleep disorder ",
    value:
      "F13182 Sedative, hypnotic or anxiolytic abuse with sedative, hypnotic or anxiolytic-induced sleep disorder ",
  },
  {
    label:
      "F13188 Sedative, hypnotic or anxiolytic abuse with other sedative, hypnotic or anxiolytic-induced disorder ",
    value:
      "F13188 Sedative, hypnotic or anxiolytic abuse with other sedative, hypnotic or anxiolytic-induced disorder ",
  },
  {
    label:
      "F1319 Sedative, hypnotic or anxiolytic abuse with unspecified sedative, hypnotic or anxiolytic-induced disorder ",
    value:
      "F1319 Sedative, hypnotic or anxiolytic abuse with unspecified sedative, hypnotic or anxiolytic-induced disorder ",
  },
  {
    label: "F1320 Sedative, hypnotic or anxiolytic dependence, uncomplicated ",
    value: "F1320 Sedative, hypnotic or anxiolytic dependence, uncomplicated ",
  },
  {
    label: "F1321 Sedative, hypnotic or anxiolytic dependence, in remission ",
    value: "F1321 Sedative, hypnotic or anxiolytic dependence, in remission ",
  },
  {
    label:
      "F13220 Sedative, hypnotic or anxiolytic dependence with intoxication, uncomplicated ",
    value:
      "F13220 Sedative, hypnotic or anxiolytic dependence with intoxication, uncomplicated ",
  },
  {
    label:
      "F13221 Sedative, hypnotic or anxiolytic dependence with intoxication delirium ",
    value:
      "F13221 Sedative, hypnotic or anxiolytic dependence with intoxication delirium ",
  },
  {
    label:
      "F13229 Sedative, hypnotic or anxiolytic dependence with intoxication, unspecified ",
    value:
      "F13229 Sedative, hypnotic or anxiolytic dependence with intoxication, unspecified ",
  },
  {
    label:
      "F13230 Sedative, hypnotic or anxiolytic dependence with withdrawal, uncomplicated ",
    value:
      "F13230 Sedative, hypnotic or anxiolytic dependence with withdrawal, uncomplicated ",
  },
  {
    label:
      "F13231 Sedative, hypnotic or anxiolytic dependence with withdrawal delirium ",
    value:
      "F13231 Sedative, hypnotic or anxiolytic dependence with withdrawal delirium ",
  },
  {
    label:
      "F13232 Sedative, hypnotic or anxiolytic dependence with withdrawal with perceptual disturbance ",
    value:
      "F13232 Sedative, hypnotic or anxiolytic dependence with withdrawal with perceptual disturbance ",
  },
  {
    label:
      "F13239 Sedative, hypnotic or anxiolytic dependence with withdrawal, unspecified ",
    value:
      "F13239 Sedative, hypnotic or anxiolytic dependence with withdrawal, unspecified ",
  },
  {
    label:
      "F1324 Sedative, hypnotic or anxiolytic dependence with sedative, hypnotic or anxiolytic-induced mood disorder ",
    value:
      "F1324 Sedative, hypnotic or anxiolytic dependence with sedative, hypnotic or anxiolytic-induced mood disorder ",
  },
  {
    label:
      "F13250 Sedative, hypnotic or anxiolytic dependence with sedative, hypnotic or anxiolytic-induced psychotic disorder with delusions ",
    value:
      "F13250 Sedative, hypnotic or anxiolytic dependence with sedative, hypnotic or anxiolytic-induced psychotic disorder with delusions ",
  },
  {
    label:
      "F13251 Sedative, hypnotic or anxiolytic dependence with sedative, hypnotic or anxiolytic-induced psychotic disorder with hallucinations ",
    value:
      "F13251 Sedative, hypnotic or anxiolytic dependence with sedative, hypnotic or anxiolytic-induced psychotic disorder with hallucinations ",
  },
  {
    label:
      "F13259 Sedative, hypnotic or anxiolytic dependence with sedative, hypnotic or anxiolytic-induced psychotic disorder, unspecified ",
    value:
      "F13259 Sedative, hypnotic or anxiolytic dependence with sedative, hypnotic or anxiolytic-induced psychotic disorder, unspecified ",
  },
  {
    label:
      "F1326 Sedative, hypnotic or anxiolytic dependence with sedative, hypnotic or anxiolytic-induced persisting amnestic disorder ",
    value:
      "F1326 Sedative, hypnotic or anxiolytic dependence with sedative, hypnotic or anxiolytic-induced persisting amnestic disorder ",
  },
  {
    label:
      "F1327 Sedative, hypnotic or anxiolytic dependence with sedative, hypnotic or anxiolytic-induced persisting dementia ",
    value:
      "F1327 Sedative, hypnotic or anxiolytic dependence with sedative, hypnotic or anxiolytic-induced persisting dementia ",
  },
  {
    label:
      "F13280 Sedative, hypnotic or anxiolytic dependence with sedative, hypnotic or anxiolytic-induced anxiety disorder ",
    value:
      "F13280 Sedative, hypnotic or anxiolytic dependence with sedative, hypnotic or anxiolytic-induced anxiety disorder ",
  },
  {
    label:
      "F13281 Sedative, hypnotic or anxiolytic dependence with sedative, hypnotic or anxiolytic-induced sexual dysfunction ",
    value:
      "F13281 Sedative, hypnotic or anxiolytic dependence with sedative, hypnotic or anxiolytic-induced sexual dysfunction ",
  },
  {
    label:
      "F13282 Sedative, hypnotic or anxiolytic dependence with sedative, hypnotic or anxiolytic-induced sleep disorder ",
    value:
      "F13282 Sedative, hypnotic or anxiolytic dependence with sedative, hypnotic or anxiolytic-induced sleep disorder ",
  },
  {
    label:
      "F13288 Sedative, hypnotic or anxiolytic dependence with other sedative, hypnotic or anxiolytic-induced disorder ",
    value:
      "F13288 Sedative, hypnotic or anxiolytic dependence with other sedative, hypnotic or anxiolytic-induced disorder ",
  },
  {
    label:
      "F1329 Sedative, hypnotic or anxiolytic dependence with unspecified sedative, hypnotic or anxiolyticinduced disorder ",
    value:
      "F1329 Sedative, hypnotic or anxiolytic dependence with unspecified sedative, hypnotic or anxiolyticinduced disorder ",
  },
  {
    label:
      "F1390 Sedative, hypnotic, or anxiolytic use, unspecified, uncomplicated ",
    value:
      "F1390 Sedative, hypnotic, or anxiolytic use, unspecified, uncomplicated ",
  },
  {
    label:
      "F13920 Sedative, hypnotic or anxiolytic use, unspecified with intoxication, uncomplicated F13921 Sedative, hypnotic or anxiolytic use, unspecified with intoxication delirium ",
    value:
      "F13920 Sedative, hypnotic or anxiolytic use, unspecified with intoxication, uncomplicated F13921 Sedative, hypnotic or anxiolytic use, unspecified with intoxication delirium ",
  },
  {
    label:
      "F13929 Sedative, hypnotic or anxiolytic use, unspecified with intoxication, unspecified ",
    value:
      "F13929 Sedative, hypnotic or anxiolytic use, unspecified with intoxication, unspecified ",
  },
  {
    label:
      "F13930 Sedative, hypnotic or anxiolytic use, unspecified with withdrawal, uncomplicated F13931 Sedative, hypnotic or anxiolytic use, unspecified with withdrawal delirium ",
    value:
      "F13930 Sedative, hypnotic or anxiolytic use, unspecified with withdrawal, uncomplicated F13931 Sedative, hypnotic or anxiolytic use, unspecified with withdrawal delirium ",
  },
  {
    label:
      "F13932 Sedative, hypnotic or anxiolytic use, unspecified with withdrawal with perceptual disturbances ",
    value:
      "F13932 Sedative, hypnotic or anxiolytic use, unspecified with withdrawal with perceptual disturbances ",
  },
  {
    label:
      "F13939 Sedative, hypnotic or anxiolytic use, unspecified with withdrawal, unspecified ",
    value:
      "F13939 Sedative, hypnotic or anxiolytic use, unspecified with withdrawal, unspecified ",
  },
  {
    label:
      "F1394 Sedative, hypnotic or anxiolytic use, unspecified with sedative, hypnotic or anxiolytic-induced mood disorder ",
    value:
      "F1394 Sedative, hypnotic or anxiolytic use, unspecified with sedative, hypnotic or anxiolytic-induced mood disorder ",
  },
  {
    label:
      "F13950 Sedative, hypnotic or anxiolytic use, unspecified with sedative, hypnotic or anxiolytic-induced psychotic disorder with delusions ",
    value:
      "F13950 Sedative, hypnotic or anxiolytic use, unspecified with sedative, hypnotic or anxiolytic-induced psychotic disorder with delusions ",
  },
  {
    label:
      "F13951 Sedative, hypnotic or anxiolytic use, unspecified with sedative, hypnotic or anxiolytic-induced psychotic disorder with hallucinations ",
    value:
      "F13951 Sedative, hypnotic or anxiolytic use, unspecified with sedative, hypnotic or anxiolytic-induced psychotic disorder with hallucinations ",
  },
  {
    label:
      "F13959 Sedative, hypnotic or anxiolytic use, unspecified with sedative, hypnotic or anxiolytic-induced psychotic disorder, unspecified ",
    value:
      "F13959 Sedative, hypnotic or anxiolytic use, unspecified with sedative, hypnotic or anxiolytic-induced psychotic disorder, unspecified ",
  },
  {
    label:
      "F1396 Sedative, hypnotic or anxiolytic use, unspecified with sedative, hypnotic or anxiolytic-induced persisting amnestic disorder ",
    value:
      "F1396 Sedative, hypnotic or anxiolytic use, unspecified with sedative, hypnotic or anxiolytic-induced persisting amnestic disorder ",
  },
  {
    label:
      "F1397 Sedative, hypnotic or anxiolytic use, unspecified with sedative, hypnotic or anxiolytic-induced persisting dementia ",
    value:
      "F1397 Sedative, hypnotic or anxiolytic use, unspecified with sedative, hypnotic or anxiolytic-induced persisting dementia ",
  },
  {
    label:
      "F13980 Sedative, hypnotic or anxiolytic use, unspecified with sedative, hypnotic or anxiolytic-induced anxiety disorder ",
    value:
      "F13980 Sedative, hypnotic or anxiolytic use, unspecified with sedative, hypnotic or anxiolytic-induced anxiety disorder ",
  },
  {
    label:
      "F13981 Sedative, hypnotic or anxiolytic use, unspecified with sedative, hypnotic or anxiolytic-induced sexual dysfunction ",
    value:
      "F13981 Sedative, hypnotic or anxiolytic use, unspecified with sedative, hypnotic or anxiolytic-induced sexual dysfunction ",
  },
  {
    label:
      "F13982 Sedative, hypnotic or anxiolytic use, unspecified with sedative, hypnotic or anxiolytic-induced sleep disorder ",
    value:
      "F13982 Sedative, hypnotic or anxiolytic use, unspecified with sedative, hypnotic or anxiolytic-induced sleep disorder ",
  },
  {
    label:
      "F13988 Sedative, hypnotic or anxiolytic use, unspecified with other sedative, hypnotic or anxiolyticinduced disorder ",
    value:
      "F13988 Sedative, hypnotic or anxiolytic use, unspecified with other sedative, hypnotic or anxiolyticinduced disorder ",
  },
  {
    label:
      "F1399 Sedative, hypnotic or anxiolytic use, unspecified with unspecified sedative, hypnotic or anxiolytic-induced disorder ",
    value:
      "F1399 Sedative, hypnotic or anxiolytic use, unspecified with unspecified sedative, hypnotic or anxiolytic-induced disorder ",
  },
  {
    label: "F1410 Cocaine abuse, uncomplicated ",
    value: "F1410 Cocaine abuse, uncomplicated ",
  },
  {
    label: "F14120 Cocaine abuse with intoxication, uncomplicated ",
    value: "F14120 Cocaine abuse with intoxication, uncomplicated ",
  },
  {
    label: "F14121 Cocaine abuse with intoxication with delirium ",
    value: "F14121 Cocaine abuse with intoxication with delirium ",
  },
  {
    label:
      "F14122 Cocaine abuse with intoxication with perceptual disturbance ",
    value:
      "F14122 Cocaine abuse with intoxication with perceptual disturbance ",
  },
  {
    label: "F14129 Cocaine abuse with intoxication, unspecified ",
    value: "F14129 Cocaine abuse with intoxication, unspecified ",
  },
  {
    label: "F1414 Cocaine abuse with cocaine-induced mood disorder ",
    value: "F1414 Cocaine abuse with cocaine-induced mood disorder ",
  },
  {
    label:
      "F14150 Cocaine abuse with cocaine-induced psychotic disorder with delusions ",
    value:
      "F14150 Cocaine abuse with cocaine-induced psychotic disorder with delusions ",
  },
  {
    label:
      "F14151 Cocaine abuse with cocaine-induced psychotic disorder with hallucinations ",
    value:
      "F14151 Cocaine abuse with cocaine-induced psychotic disorder with hallucinations ",
  },
  {
    label:
      "F14159 Cocaine abuse with cocaine-induced psychotic disorder, unspecified ",
    value:
      "F14159 Cocaine abuse with cocaine-induced psychotic disorder, unspecified ",
  },
  {
    label: "F14180 Cocaine abuse with cocaine-induced anxiety disorder ",
    value: "F14180 Cocaine abuse with cocaine-induced anxiety disorder ",
  },
  {
    label: "F14181 Cocaine abuse with cocaine-induced sexual dysfunction ",
    value: "F14181 Cocaine abuse with cocaine-induced sexual dysfunction ",
  },
  {
    label: "F14182 Cocaine abuse with cocaine-induced sleep disorder ",
    value: "F14182 Cocaine abuse with cocaine-induced sleep disorder ",
  },
  {
    label: "F14188 Cocaine abuse with other cocaine-induced disorder ",
    value: "F14188 Cocaine abuse with other cocaine-induced disorder ",
  },
  {
    label: "F1419 Cocaine abuse with unspecified cocaine-induced disorder ",
    value: "F1419 Cocaine abuse with unspecified cocaine-induced disorder ",
  },
  {
    label: "F1420 Cocaine dependence, uncomplicated ",
    value: "F1420 Cocaine dependence, uncomplicated ",
  },
  {
    label: "F1421 Cocaine dependence, in remission ",
    value: "F1421 Cocaine dependence, in remission ",
  },
  {
    label: "F14220 Cocaine dependence with intoxication, uncomplicated ",
    value: "F14220 Cocaine dependence with intoxication, uncomplicated ",
  },
  {
    label: "F14221 Cocaine dependence with intoxication delirium ",
    value: "F14221 Cocaine dependence with intoxication delirium ",
  },
  {
    label:
      "F14222 Cocaine dependence with intoxication with perceptual disturbance ",
    value:
      "F14222 Cocaine dependence with intoxication with perceptual disturbance ",
  },
  {
    label: "F14229 Cocaine dependence with intoxication, unspecified ",
    value: "F14229 Cocaine dependence with intoxication, unspecified ",
  },
  {
    label: "F1423 Cocaine dependence with withdrawal ",
    value: "F1423 Cocaine dependence with withdrawal ",
  },
  {
    label: "F1424 Cocaine dependence with cocaine-induced mood disorder ",
    value: "F1424 Cocaine dependence with cocaine-induced mood disorder ",
  },
  {
    label:
      "F14250 Cocaine dependence with cocaine-induced psychotic disorder with delusions ",
    value:
      "F14250 Cocaine dependence with cocaine-induced psychotic disorder with delusions ",
  },
  {
    label:
      "F14251 Cocaine dependence with cocaine-induced psychotic disorder with hallucinations F14259 Cocaine dependence with cocaine-induced psychotic disorder, unspecified ",
    value:
      "F14251 Cocaine dependence with cocaine-induced psychotic disorder with hallucinations F14259 Cocaine dependence with cocaine-induced psychotic disorder, unspecified ",
  },
  {
    label: "F14280 Cocaine dependence with cocaine-induced anxiety disorder ",
    value: "F14280 Cocaine dependence with cocaine-induced anxiety disorder ",
  },
  {
    label: "F14281 Cocaine dependence with cocaine-induced sexual dysfunction ",
    value: "F14281 Cocaine dependence with cocaine-induced sexual dysfunction ",
  },
  {
    label: "F14282 Cocaine dependence with cocaine-induced sleep disorder ",
    value: "F14282 Cocaine dependence with cocaine-induced sleep disorder ",
  },
  {
    label: "F14288 Cocaine dependence with other cocaine-induced disorder ",
    value: "F14288 Cocaine dependence with other cocaine-induced disorder ",
  },
  {
    label:
      "F1429 Cocaine dependence with unspecified cocaine-induced disorder ",
    value:
      "F1429 Cocaine dependence with unspecified cocaine-induced disorder ",
  },
  {
    label: "F1490 Cocaine use, unspecified, uncomplicated ",
    value: "F1490 Cocaine use, unspecified, uncomplicated ",
  },
  {
    label: "F14920 Cocaine use, unspecified with intoxication, uncomplicated ",
    value: "F14920 Cocaine use, unspecified with intoxication, uncomplicated ",
  },
  {
    label: "F14921 Cocaine use, unspecified with intoxication delirium ",
    value: "F14921 Cocaine use, unspecified with intoxication delirium ",
  },
  {
    label:
      "F14922 Cocaine use, unspecified with intoxication with perceptual disturbance ",
    value:
      "F14922 Cocaine use, unspecified with intoxication with perceptual disturbance ",
  },
  {
    label: "F14929 Cocaine use, unspecified with intoxication, unspecified ",
    value: "F14929 Cocaine use, unspecified with intoxication, unspecified ",
  },
  {
    label: "F1494 Cocaine use, unspecified with cocaine-induced mood disorder ",
    value: "F1494 Cocaine use, unspecified with cocaine-induced mood disorder ",
  },
  {
    label:
      "F14950 Cocaine use, unspecified with cocaine-induced psychotic disorder with delusions F14951 Cocaine use, unspecified with cocaine-induced psychotic disorder with hallucinations F14959 Cocaine use, unspecified with cocaine-induced psychotic disorder, unspecified ",
    value:
      "F14950 Cocaine use, unspecified with cocaine-induced psychotic disorder with delusions F14951 Cocaine use, unspecified with cocaine-induced psychotic disorder with hallucinations F14959 Cocaine use, unspecified with cocaine-induced psychotic disorder, unspecified ",
  },
  {
    label:
      "F14980 Cocaine use, unspecified with cocaine-induced anxiety disorder ",
    value:
      "F14980 Cocaine use, unspecified with cocaine-induced anxiety disorder ",
  },
  {
    label:
      "F14981 Cocaine use, unspecified with cocaine-induced sexual dysfunction ",
    value:
      "F14981 Cocaine use, unspecified with cocaine-induced sexual dysfunction ",
  },
  {
    label:
      "F14982 Cocaine use, unspecified with cocaine-induced sleep disorder ",
    value:
      "F14982 Cocaine use, unspecified with cocaine-induced sleep disorder ",
  },
  {
    label:
      "F14988 Cocaine use, unspecified with other cocaine-induced disorder ",
    value:
      "F14988 Cocaine use, unspecified with other cocaine-induced disorder ",
  },
  {
    label:
      "F1499 Cocaine use, unspecified with unspecified cocaine-induced disorder ",
    value:
      "F1499 Cocaine use, unspecified with unspecified cocaine-induced disorder ",
  },
  {
    label: "F1510 Other stimulant abuse, uncomplicated ",
    value: "F1510 Other stimulant abuse, uncomplicated ",
  },
  {
    label: "F15120 Other stimulant abuse with intoxication, uncomplicated ",
    value: "F15120 Other stimulant abuse with intoxication, uncomplicated ",
  },
  {
    label: "F15121 Other stimulant abuse with intoxication delirium ",
    value: "F15121 Other stimulant abuse with intoxication delirium ",
  },
  {
    label:
      "F15122 Other stimulant abuse with intoxication with perceptual disturbance ",
    value:
      "F15122 Other stimulant abuse with intoxication with perceptual disturbance ",
  },
  {
    label: "F15129 Other stimulant abuse with intoxication, unspecified ",
    value: "F15129 Other stimulant abuse with intoxication, unspecified ",
  },
  {
    label: "F1514 Other stimulant abuse with stimulant-induced mood disorder ",
    value: "F1514 Other stimulant abuse with stimulant-induced mood disorder ",
  },
  {
    label:
      "F15150 Other stimulant abuse with stimulant-induced psychotic disorder with delusions ",
    value:
      "F15150 Other stimulant abuse with stimulant-induced psychotic disorder with delusions ",
  },
  {
    label:
      "F15151 Other stimulant abuse with stimulant-induced psychotic disorder with hallucinations F15159 Other stimulant abuse with stimulant-induced psychotic disorder, unspecified ",
    value:
      "F15151 Other stimulant abuse with stimulant-induced psychotic disorder with hallucinations F15159 Other stimulant abuse with stimulant-induced psychotic disorder, unspecified ",
  },
  {
    label:
      "F15180 Other stimulant abuse with stimulant-induced anxiety disorder ",
    value:
      "F15180 Other stimulant abuse with stimulant-induced anxiety disorder ",
  },
  {
    label:
      "F15181 Other stimulant abuse with stimulant-induced sexual dysfunction ",
    value:
      "F15181 Other stimulant abuse with stimulant-induced sexual dysfunction ",
  },
  {
    label:
      "F15182 Other stimulant abuse with stimulant-induced sleep disorder ",
    value:
      "F15182 Other stimulant abuse with stimulant-induced sleep disorder ",
  },
  {
    label:
      "F15188 Other stimulant abuse with other stimulant-induced disorder ",
    value:
      "F15188 Other stimulant abuse with other stimulant-induced disorder ",
  },
  {
    label:
      "F1519 Other stimulant abuse with unspecified stimulant-induced disorder ",
    value:
      "F1519 Other stimulant abuse with unspecified stimulant-induced disorder ",
  },
  {
    label: "F1520 Other stimulant dependence, uncomplicated ",
    value: "F1520 Other stimulant dependence, uncomplicated ",
  },
  {
    label: "F1521 Other stimulant dependence, in remission ",
    value: "F1521 Other stimulant dependence, in remission ",
  },
  {
    label:
      "F15220 Other stimulant dependence with intoxication, uncomplicated ",
    value:
      "F15220 Other stimulant dependence with intoxication, uncomplicated ",
  },
  {
    label: "F15221 Other stimulant dependence with intoxication delirium ",
    value: "F15221 Other stimulant dependence with intoxication delirium ",
  },
  {
    label:
      "F15222 Other stimulant dependence with intoxication with perceptual disturbance ",
    value:
      "F15222 Other stimulant dependence with intoxication with perceptual disturbance ",
  },
  {
    label: "F15229 Other stimulant dependence with intoxication, unspecified ",
    value: "F15229 Other stimulant dependence with intoxication, unspecified ",
  },
  {
    label: "F1523 Other stimulant dependence with withdrawal ",
    value: "F1523 Other stimulant dependence with withdrawal ",
  },
  {
    label:
      "F1524 Other stimulant dependence with stimulant-induced mood disorder ",
    value:
      "F1524 Other stimulant dependence with stimulant-induced mood disorder ",
  },
  {
    label:
      "F15250 Other stimulant dependence with stimulant-induced psychotic disorder with delusions F15251 Other stimulant dependence with stimulant-induced psychotic disorder with hallucinations ",
    value:
      "F15250 Other stimulant dependence with stimulant-induced psychotic disorder with delusions F15251 Other stimulant dependence with stimulant-induced psychotic disorder with hallucinations ",
  },
  {
    label:
      "F15259 Other stimulant dependence with stimulant-induced psychotic disorder, unspecified F15280 Other stimulant dependence with stimulant-induced anxiety disorder ",
    value:
      "F15259 Other stimulant dependence with stimulant-induced psychotic disorder, unspecified F15280 Other stimulant dependence with stimulant-induced anxiety disorder ",
  },
  {
    label:
      "F15281 Other stimulant dependence with stimulant-induced sexual dysfunction ",
    value:
      "F15281 Other stimulant dependence with stimulant-induced sexual dysfunction ",
  },
  {
    label:
      "F15282 Other stimulant dependence with stimulant-induced sleep disorder ",
    value:
      "F15282 Other stimulant dependence with stimulant-induced sleep disorder ",
  },
  {
    label:
      "F15288 Other stimulant dependence with other stimulant-induced disorder ",
    value:
      "F15288 Other stimulant dependence with other stimulant-induced disorder ",
  },
  {
    label:
      "F1529 Other stimulant dependence with unspecified stimulant-induced disorder ",
    value:
      "F1529 Other stimulant dependence with unspecified stimulant-induced disorder ",
  },
  {
    label: "F1590 Other stimulant use, unspecified, uncomplicated ",
    value: "F1590 Other stimulant use, unspecified, uncomplicated ",
  },
  {
    label:
      "F15920 Other stimulant use, unspecified with intoxication, uncomplicated ",
    value:
      "F15920 Other stimulant use, unspecified with intoxication, uncomplicated ",
  },
  {
    label:
      "F15921 Other stimulant use, unspecified with intoxication delirium ",
    value:
      "F15921 Other stimulant use, unspecified with intoxication delirium ",
  },
  {
    label:
      "F15922 Other stimulant use, unspecified with intoxication with perceptual disturbance ",
    value:
      "F15922 Other stimulant use, unspecified with intoxication with perceptual disturbance ",
  },
  {
    label:
      "F15929 Other stimulant use, unspecified with intoxication, unspecified ",
    value:
      "F15929 Other stimulant use, unspecified with intoxication, unspecified ",
  },
  {
    label: "F1593 Other stimulant use, unspecified with withdrawal ",
    value: "F1593 Other stimulant use, unspecified with withdrawal ",
  },
  {
    label:
      "F1594 Other stimulant use, unspecified with stimulant-induced mood disorder ",
    value:
      "F1594 Other stimulant use, unspecified with stimulant-induced mood disorder ",
  },
  {
    label:
      "F15950 Other stimulant use, unspecified with stimulant-induced psychotic disorder with delusions ",
    value:
      "F15950 Other stimulant use, unspecified with stimulant-induced psychotic disorder with delusions ",
  },
  {
    label:
      "F15951 Other stimulant use, unspecified with stimulant-induced psychotic disorder with hallucinations ",
    value:
      "F15951 Other stimulant use, unspecified with stimulant-induced psychotic disorder with hallucinations ",
  },
  {
    label:
      "F15959 Other stimulant use, unspecified with stimulant-induced psychotic disorder, unspecified F15980 Other stimulant use, unspecified with stimulant-induced anxiety disorder ",
    value:
      "F15959 Other stimulant use, unspecified with stimulant-induced psychotic disorder, unspecified F15980 Other stimulant use, unspecified with stimulant-induced anxiety disorder ",
  },
  {
    label:
      "F15981 Other stimulant use, unspecified with stimulant-induced sexual dysfunction ",
    value:
      "F15981 Other stimulant use, unspecified with stimulant-induced sexual dysfunction ",
  },
  {
    label:
      "F15982 Other stimulant use, unspecified with stimulant-induced sleep disorder ",
    value:
      "F15982 Other stimulant use, unspecified with stimulant-induced sleep disorder ",
  },
  {
    label:
      "F15988 Other stimulant use, unspecified with other stimulant-induced disorder ",
    value:
      "F15988 Other stimulant use, unspecified with other stimulant-induced disorder ",
  },
  {
    label:
      "F1599 Other stimulant use, unspecified with unspecified stimulant-induced disorder ",
    value:
      "F1599 Other stimulant use, unspecified with unspecified stimulant-induced disorder ",
  },
  {
    label: "F1610 Hallucinogen abuse, uncomplicated ",
    value: "F1610 Hallucinogen abuse, uncomplicated ",
  },
  {
    label: "F16120 Hallucinogen abuse with intoxication, uncomplicated ",
    value: "F16120 Hallucinogen abuse with intoxication, uncomplicated ",
  },
  {
    label: "F16121 Hallucinogen abuse with intoxication with delirium ",
    value: "F16121 Hallucinogen abuse with intoxication with delirium ",
  },
  {
    label:
      "F16122 Hallucinogen abuse with intoxication with perceptual disturbance ",
    value:
      "F16122 Hallucinogen abuse with intoxication with perceptual disturbance ",
  },
  {
    label: "F16129 Hallucinogen abuse with intoxication, unspecified ",
    value: "F16129 Hallucinogen abuse with intoxication, unspecified ",
  },
  {
    label: "F1614 Hallucinogen abuse with hallucinogen-induced mood disorder ",
    value: "F1614 Hallucinogen abuse with hallucinogen-induced mood disorder ",
  },
  {
    label:
      "F16150 Hallucinogen abuse with hallucinogen-induced psychotic disorder with delusions F16151 Hallucinogen abuse with hallucinogen-induced psychotic disorder with hallucinations F16159 Hallucinogen abuse with hallucinogen-induced psychotic disorder, unspecified ",
    value:
      "F16150 Hallucinogen abuse with hallucinogen-induced psychotic disorder with delusions F16151 Hallucinogen abuse with hallucinogen-induced psychotic disorder with hallucinations F16159 Hallucinogen abuse with hallucinogen-induced psychotic disorder, unspecified ",
  },
  {
    label:
      "F16180 Hallucinogen abuse with hallucinogen-induced anxiety disorder ",
    value:
      "F16180 Hallucinogen abuse with hallucinogen-induced anxiety disorder ",
  },
  {
    label:
      "F16183 Hallucinogen abuse with hallucinogen persisting perception disorder (flashbacks) F16188 Hallucinogen abuse with other hallucinogen-induced disorder ",
    value:
      "F16183 Hallucinogen abuse with hallucinogen persisting perception disorder (flashbacks) F16188 Hallucinogen abuse with other hallucinogen-induced disorder ",
  },
  {
    label:
      "F1619 Hallucinogen abuse with unspecified hallucinogen-induced disorder ",
    value:
      "F1619 Hallucinogen abuse with unspecified hallucinogen-induced disorder ",
  },
  {
    label: "F1620 Hallucinogen dependence, uncomplicated ",
    value: "F1620 Hallucinogen dependence, uncomplicated ",
  },
  {
    label: "F1621 Hallucinogen dependence, in remission ",
    value: "F1621 Hallucinogen dependence, in remission ",
  },
  {
    label: "F16220 Hallucinogen dependence with intoxication, uncomplicated ",
    value: "F16220 Hallucinogen dependence with intoxication, uncomplicated ",
  },
  {
    label: "F16221 Hallucinogen dependence with intoxication with delirium ",
    value: "F16221 Hallucinogen dependence with intoxication with delirium ",
  },
  {
    label: "F16229 Hallucinogen dependence with intoxication, unspecified ",
    value: "F16229 Hallucinogen dependence with intoxication, unspecified ",
  },
  {
    label:
      "F1624 Hallucinogen dependence with hallucinogen-induced mood disorder ",
    value:
      "F1624 Hallucinogen dependence with hallucinogen-induced mood disorder ",
  },
  {
    label:
      "F16250 Hallucinogen dependence with hallucinogen-induced psychotic disorder with delusions F16251 Hallucinogen dependence with hallucinogen-induced psychotic disorder with hallucinations ",
    value:
      "F16250 Hallucinogen dependence with hallucinogen-induced psychotic disorder with delusions F16251 Hallucinogen dependence with hallucinogen-induced psychotic disorder with hallucinations ",
  },
  {
    label:
      "F16259 Hallucinogen dependence with hallucinogen-induced psychotic disorder, unspecified F16280 Hallucinogen dependence with hallucinogen-induced anxiety disorder ",
    value:
      "F16259 Hallucinogen dependence with hallucinogen-induced psychotic disorder, unspecified F16280 Hallucinogen dependence with hallucinogen-induced anxiety disorder ",
  },
  {
    label:
      "F16283 Hallucinogen dependence with hallucinogen persisting perception disorder (flashbacks) F16288 Hallucinogen dependence with other hallucinogen-induced disorder ",
    value:
      "F16283 Hallucinogen dependence with hallucinogen persisting perception disorder (flashbacks) F16288 Hallucinogen dependence with other hallucinogen-induced disorder ",
  },
  {
    label:
      "F1629 Hallucinogen dependence with unspecified hallucinogen-induced disorder ",
    value:
      "F1629 Hallucinogen dependence with unspecified hallucinogen-induced disorder ",
  },
  {
    label: "F1690 Hallucinogen use, unspecified, uncomplicated ",
    value: "F1690 Hallucinogen use, unspecified, uncomplicated ",
  },
  {
    label:
      "F16920 Hallucinogen use, unspecified with intoxication, uncomplicated ",
    value:
      "F16920 Hallucinogen use, unspecified with intoxication, uncomplicated ",
  },
  {
    label:
      "F16921 Hallucinogen use, unspecified with intoxication with delirium ",
    value:
      "F16921 Hallucinogen use, unspecified with intoxication with delirium ",
  },
  {
    label:
      "F16929 Hallucinogen use, unspecified with intoxication, unspecified ",
    value:
      "F16929 Hallucinogen use, unspecified with intoxication, unspecified ",
  },
  {
    label:
      "F1694 Hallucinogen use, unspecified with hallucinogen-induced mood disorder ",
    value:
      "F1694 Hallucinogen use, unspecified with hallucinogen-induced mood disorder ",
  },
  {
    label:
      "F16950 Hallucinogen use, unspecified with hallucinogen-induced psychotic disorder with delusions ",
    value:
      "F16950 Hallucinogen use, unspecified with hallucinogen-induced psychotic disorder with delusions ",
  },
  {
    label:
      "F16951 Hallucinogen use, unspecified with hallucinogen-induced psychotic disorder with hallucinations ",
    value:
      "F16951 Hallucinogen use, unspecified with hallucinogen-induced psychotic disorder with hallucinations ",
  },
  {
    label:
      "F16959 Hallucinogen use, unspecified with hallucinogen-induced psychotic disorder, unspecified ",
    value:
      "F16959 Hallucinogen use, unspecified with hallucinogen-induced psychotic disorder, unspecified ",
  },
  {
    label:
      "F16980 Hallucinogen use, unspecified with hallucinogen-induced anxiety disorder ",
    value:
      "F16980 Hallucinogen use, unspecified with hallucinogen-induced anxiety disorder ",
  },
  {
    label:
      "F16983 Hallucinogen use, unspecified with hallucinogen persisting perception disorder (flashbacks) ",
    value:
      "F16983 Hallucinogen use, unspecified with hallucinogen persisting perception disorder (flashbacks) ",
  },
  {
    label:
      "F16988 Hallucinogen use, unspecified with other hallucinogen-induced disorder ",
    value:
      "F16988 Hallucinogen use, unspecified with other hallucinogen-induced disorder ",
  },
  {
    label:
      "F1699 Hallucinogen use, unspecified with unspecified hallucinogen-induced disorder ",
    value:
      "F1699 Hallucinogen use, unspecified with unspecified hallucinogen-induced disorder ",
  },
  {
    label: "F17200 Nicotine dependence, unspecified, uncomplicated ",
    value: "F17200 Nicotine dependence, unspecified, uncomplicated ",
  },
  {
    label: "F17201 Nicotine dependence, unspecified, in remission ",
    value: "F17201 Nicotine dependence, unspecified, in remission ",
  },
  {
    label: "F17203 Nicotine dependence unspecified, with withdrawal ",
    value: "F17203 Nicotine dependence unspecified, with withdrawal ",
  },
  {
    label:
      "F17208 Nicotine dependence, unspecified, with other nicotine-induced disorders ",
    value:
      "F17208 Nicotine dependence, unspecified, with other nicotine-induced disorders ",
  },
  {
    label:
      "F17209 Nicotine dependence, unspecified, with unspecified nicotine-induced disorders ",
    value:
      "F17209 Nicotine dependence, unspecified, with unspecified nicotine-induced disorders ",
  },
  {
    label: "F17210 Nicotine dependence, cigarettes, uncomplicated ",
    value: "F17210 Nicotine dependence, cigarettes, uncomplicated ",
  },
  {
    label: "F17211 Nicotine dependence, cigarettes, in remission ",
    value: "F17211 Nicotine dependence, cigarettes, in remission ",
  },
  {
    label: "F17213 Nicotine dependence, cigarettes, with withdrawal ",
    value: "F17213 Nicotine dependence, cigarettes, with withdrawal ",
  },
  {
    label:
      "F17218 Nicotine dependence, cigarettes, with other nicotine-induced disorders ",
    value:
      "F17218 Nicotine dependence, cigarettes, with other nicotine-induced disorders ",
  },
  {
    label:
      "F17219 Nicotine dependence, cigarettes, with unspecified nicotine-induced disorders ",
    value:
      "F17219 Nicotine dependence, cigarettes, with unspecified nicotine-induced disorders ",
  },
  {
    label: "F17220 Nicotine dependence, chewing tobacco, uncomplicated ",
    value: "F17220 Nicotine dependence, chewing tobacco, uncomplicated ",
  },
  {
    label: "F17221 Nicotine dependence, chewing tobacco, in remission ",
    value: "F17221 Nicotine dependence, chewing tobacco, in remission ",
  },
  {
    label: "F17223 Nicotine dependence, chewing tobacco, with withdrawal ",
    value: "F17223 Nicotine dependence, chewing tobacco, with withdrawal ",
  },
  {
    label:
      "F17228 Nicotine dependence, chewing tobacco, with other nicotine-induced disorders ",
    value:
      "F17228 Nicotine dependence, chewing tobacco, with other nicotine-induced disorders ",
  },
  {
    label:
      "F17229 Nicotine dependence, chewing tobacco, with unspecified nicotine-induced disorders F17290 Nicotine dependence, other tobacco product, uncomplicated ",
    value:
      "F17229 Nicotine dependence, chewing tobacco, with unspecified nicotine-induced disorders F17290 Nicotine dependence, other tobacco product, uncomplicated ",
  },
  {
    label: "F17291 Nicotine dependence, other tobacco product, in remission ",
    value: "F17291 Nicotine dependence, other tobacco product, in remission ",
  },
  {
    label:
      "F17293 Nicotine dependence, other tobacco product, with withdrawal ",
    value:
      "F17293 Nicotine dependence, other tobacco product, with withdrawal ",
  },
  {
    label:
      "F17298 Nicotine dependence, other tobacco product, with other nicotine-induced disorders F17299 Nicotine dependence, other tobacco product, with unspecified nicotine-induced disorders ",
    value:
      "F17298 Nicotine dependence, other tobacco product, with other nicotine-induced disorders F17299 Nicotine dependence, other tobacco product, with unspecified nicotine-induced disorders ",
  },
  {
    label: "F1810 Inhalant abuse, uncomplicated ",
    value: "F1810 Inhalant abuse, uncomplicated ",
  },
  {
    label: "F18120 Inhalant abuse with intoxication, uncomplicated ",
    value: "F18120 Inhalant abuse with intoxication, uncomplicated ",
  },
  {
    label: "F18121 Inhalant abuse with intoxication delirium ",
    value: "F18121 Inhalant abuse with intoxication delirium ",
  },
  {
    label: "F18129 Inhalant abuse with intoxication, unspecified ",
    value: "F18129 Inhalant abuse with intoxication, unspecified ",
  },
  {
    label: "F1814 Inhalant abuse with inhalant-induced mood disorder ",
    value: "F1814 Inhalant abuse with inhalant-induced mood disorder ",
  },
  {
    label:
      "F18150 Inhalant abuse with inhalant-induced psychotic disorder with delusions ",
    value:
      "F18150 Inhalant abuse with inhalant-induced psychotic disorder with delusions ",
  },
  {
    label:
      "F18151 Inhalant abuse with inhalant-induced psychotic disorder with hallucinations ",
    value:
      "F18151 Inhalant abuse with inhalant-induced psychotic disorder with hallucinations ",
  },
  {
    label:
      "F18159 Inhalant abuse with inhalant-induced psychotic disorder, unspecified ",
    value:
      "F18159 Inhalant abuse with inhalant-induced psychotic disorder, unspecified ",
  },
  {
    label: "F1817 Inhalant abuse with inhalant-induced dementia ",
    value: "F1817 Inhalant abuse with inhalant-induced dementia ",
  },
  {
    label: "F18180 Inhalant abuse with inhalant-induced anxiety disorder ",
    value: "F18180 Inhalant abuse with inhalant-induced anxiety disorder ",
  },
  {
    label: "F18188 Inhalant abuse with other inhalant-induced disorder ",
    value: "F18188 Inhalant abuse with other inhalant-induced disorder ",
  },
  {
    label: "F1819 Inhalant abuse with unspecified inhalant-induced disorder ",
    value: "F1819 Inhalant abuse with unspecified inhalant-induced disorder ",
  },
  {
    label: "F1820 Inhalant dependence, uncomplicated ",
    value: "F1820 Inhalant dependence, uncomplicated ",
  },
  {
    label: "F1821 Inhalant dependence, in remission ",
    value: "F1821 Inhalant dependence, in remission ",
  },
  {
    label: "F18220 Inhalant dependence with intoxication, uncomplicated ",
    value: "F18220 Inhalant dependence with intoxication, uncomplicated ",
  },
  {
    label: "F18221 Inhalant dependence with intoxication delirium ",
    value: "F18221 Inhalant dependence with intoxication delirium ",
  },
  {
    label: "F18229 Inhalant dependence with intoxication, unspecified ",
    value: "F18229 Inhalant dependence with intoxication, unspecified ",
  },
  {
    label: "F1824 Inhalant dependence with inhalant-induced mood disorder ",
    value: "F1824 Inhalant dependence with inhalant-induced mood disorder ",
  },
  {
    label:
      "F18250 Inhalant dependence with inhalant-induced psychotic disorder with delusions ",
    value:
      "F18250 Inhalant dependence with inhalant-induced psychotic disorder with delusions ",
  },
  {
    label:
      "F18251 Inhalant dependence with inhalant-induced psychotic disorder with hallucinations F18259 Inhalant dependence with inhalant-induced psychotic disorder, unspecified ",
    value:
      "F18251 Inhalant dependence with inhalant-induced psychotic disorder with hallucinations F18259 Inhalant dependence with inhalant-induced psychotic disorder, unspecified ",
  },
  {
    label: "F1827 Inhalant dependence with inhalant-induced dementia ",
    value: "F1827 Inhalant dependence with inhalant-induced dementia ",
  },
  {
    label: "F18280 Inhalant dependence with inhalant-induced anxiety disorder ",
    value: "F18280 Inhalant dependence with inhalant-induced anxiety disorder ",
  },
  {
    label: "F18288 Inhalant dependence with other inhalant-induced disorder ",
    value: "F18288 Inhalant dependence with other inhalant-induced disorder ",
  },
  {
    label:
      "F1829 Inhalant dependence with unspecified inhalant-induced disorder ",
    value:
      "F1829 Inhalant dependence with unspecified inhalant-induced disorder ",
  },
  {
    label: "F1890 Inhalant use, unspecified, uncomplicated ",
    value: "F1890 Inhalant use, unspecified, uncomplicated ",
  },
  {
    label: "F18920 Inhalant use, unspecified with intoxication, uncomplicated ",
    value: "F18920 Inhalant use, unspecified with intoxication, uncomplicated ",
  },
  {
    label: "F18921 Inhalant use, unspecified with intoxication with delirium ",
    value: "F18921 Inhalant use, unspecified with intoxication with delirium ",
  },
  {
    label: "F18929 Inhalant use, unspecified with intoxication, unspecified ",
    value: "F18929 Inhalant use, unspecified with intoxication, unspecified ",
  },
  {
    label:
      "F1894 Inhalant use, unspecified with inhalant-induced mood disorder ",
    value:
      "F1894 Inhalant use, unspecified with inhalant-induced mood disorder ",
  },
  {
    label:
      "F18950 Inhalant use, unspecified with inhalant-induced psychotic disorder with delusions F18951 Inhalant use, unspecified with inhalant-induced psychotic disorder with hallucinations F18959 Inhalant use, unspecified with inhalant-induced psychotic disorder, unspecified ",
    value:
      "F18950 Inhalant use, unspecified with inhalant-induced psychotic disorder with delusions F18951 Inhalant use, unspecified with inhalant-induced psychotic disorder with hallucinations F18959 Inhalant use, unspecified with inhalant-induced psychotic disorder, unspecified ",
  },
  {
    label:
      "F1897 Inhalant use, unspecified with inhalant-induced persisting dementia ",
    value:
      "F1897 Inhalant use, unspecified with inhalant-induced persisting dementia ",
  },
  {
    label:
      "F18980 Inhalant use, unspecified with inhalant-induced anxiety disorder ",
    value:
      "F18980 Inhalant use, unspecified with inhalant-induced anxiety disorder ",
  },
  {
    label:
      "F18988 Inhalant use, unspecified with other inhalant-induced disorder ",
    value:
      "F18988 Inhalant use, unspecified with other inhalant-induced disorder ",
  },
  {
    label:
      "F1899 Inhalant use, unspecified with unspecified inhalant-induced disorder ",
    value:
      "F1899 Inhalant use, unspecified with unspecified inhalant-induced disorder ",
  },
  {
    label: "F1910 Other psychoactive substance abuse, uncomplicated ",
    value: "F1910 Other psychoactive substance abuse, uncomplicated ",
  },
  {
    label:
      "F19120 Other psychoactive substance abuse with intoxication, uncomplicated ",
    value:
      "F19120 Other psychoactive substance abuse with intoxication, uncomplicated ",
  },
  {
    label:
      "F19121 Other psychoactive substance abuse with intoxication delirium ",
    value:
      "F19121 Other psychoactive substance abuse with intoxication delirium ",
  },
  {
    label:
      "F19122 Other psychoactive substance abuse with intoxication with perceptual disturbances F19129 Other psychoactive substance abuse with intoxication, unspecified ",
    value:
      "F19122 Other psychoactive substance abuse with intoxication with perceptual disturbances F19129 Other psychoactive substance abuse with intoxication, unspecified ",
  },
  {
    label:
      "F1914 Other psychoactive substance abuse with psychoactive substance-induced mood disorder ",
    value:
      "F1914 Other psychoactive substance abuse with psychoactive substance-induced mood disorder ",
  },
  {
    label:
      "F19150 Other psychoactive substance abuse with psychoactive substance-induced psychotic disorder with delusions ",
    value:
      "F19150 Other psychoactive substance abuse with psychoactive substance-induced psychotic disorder with delusions ",
  },
  {
    label:
      "F19151 Other psychoactive substance abuse with psychoactive substance-induced psychotic disorder with hallucinations ",
    value:
      "F19151 Other psychoactive substance abuse with psychoactive substance-induced psychotic disorder with hallucinations ",
  },
  {
    label:
      "F19159 Other psychoactive substance abuse with psychoactive substance-induced psychotic disorder, unspecified ",
    value:
      "F19159 Other psychoactive substance abuse with psychoactive substance-induced psychotic disorder, unspecified ",
  },
  {
    label:
      "F1916 Other psychoactive substance abuse with psychoactive substance-induced persisting amnestic disorder ",
    value:
      "F1916 Other psychoactive substance abuse with psychoactive substance-induced persisting amnestic disorder ",
  },
  {
    label:
      "F1917 Other psychoactive substance abuse with psychoactive substance-induced persisting dementia ",
    value:
      "F1917 Other psychoactive substance abuse with psychoactive substance-induced persisting dementia ",
  },
  {
    label:
      "F19180 Other psychoactive substance abuse with psychoactive substance-induced anxiety disorder ",
    value:
      "F19180 Other psychoactive substance abuse with psychoactive substance-induced anxiety disorder ",
  },
  {
    label:
      "F19181 Other psychoactive substance abuse with psychoactive substance-induced sexual dysfunction ",
    value:
      "F19181 Other psychoactive substance abuse with psychoactive substance-induced sexual dysfunction ",
  },
  {
    label:
      "F19182 Other psychoactive substance abuse with psychoactive substance-induced sleep disorder ",
    value:
      "F19182 Other psychoactive substance abuse with psychoactive substance-induced sleep disorder ",
  },
  {
    label:
      "F19188 Other psychoactive substance abuse with other psychoactive substance-induced disorder ",
    value:
      "F19188 Other psychoactive substance abuse with other psychoactive substance-induced disorder ",
  },
  {
    label:
      "F1919 Other psychoactive substance abuse with unspecified psychoactive substance-induced disorder ",
    value:
      "F1919 Other psychoactive substance abuse with unspecified psychoactive substance-induced disorder ",
  },
  {
    label: "F1920 Other psychoactive substance dependence, uncomplicated ",
    value: "F1920 Other psychoactive substance dependence, uncomplicated ",
  },
  {
    label: "F1921 Other psychoactive substance dependence, in remission ",
    value: "F1921 Other psychoactive substance dependence, in remission ",
  },
  {
    label:
      "F19220 Other psychoactive substance dependence with intoxication, uncomplicated ",
    value:
      "F19220 Other psychoactive substance dependence with intoxication, uncomplicated ",
  },
  {
    label:
      "F19221 Other psychoactive substance dependence with intoxication delirium ",
    value:
      "F19221 Other psychoactive substance dependence with intoxication delirium ",
  },
  {
    label:
      "F19222 Other psychoactive substance dependence with intoxication with perceptual disturbance ",
    value:
      "F19222 Other psychoactive substance dependence with intoxication with perceptual disturbance ",
  },
  {
    label:
      "F19229 Other psychoactive substance dependence with intoxication, unspecified ",
    value:
      "F19229 Other psychoactive substance dependence with intoxication, unspecified ",
  },
  {
    label:
      "F19230 Other psychoactive substance dependence with withdrawal, uncomplicated ",
    value:
      "F19230 Other psychoactive substance dependence with withdrawal, uncomplicated ",
  },
  {
    label:
      "F19231 Other psychoactive substance dependence with withdrawal delirium ",
    value:
      "F19231 Other psychoactive substance dependence with withdrawal delirium ",
  },
  {
    label:
      "F19232 Other psychoactive substance dependence with withdrawal with perceptual disturbance F19239 Other psychoactive substance dependence with withdrawal, unspecified ",
    value:
      "F19232 Other psychoactive substance dependence with withdrawal with perceptual disturbance F19239 Other psychoactive substance dependence with withdrawal, unspecified ",
  },
  {
    label:
      "F1924 Other psychoactive substance dependence with psychoactive substance-induced mood disorder ",
    value:
      "F1924 Other psychoactive substance dependence with psychoactive substance-induced mood disorder ",
  },
  {
    label:
      "F19250 Other psychoactive substance dependence with psychoactive substance-induced psychotic disorder with delusions ",
    value:
      "F19250 Other psychoactive substance dependence with psychoactive substance-induced psychotic disorder with delusions ",
  },
  {
    label:
      "F19251 Other psychoactive substance dependence with psychoactive substance-induced psychotic disorder with hallucinations ",
    value:
      "F19251 Other psychoactive substance dependence with psychoactive substance-induced psychotic disorder with hallucinations ",
  },
  {
    label:
      "F19259 Other psychoactive substance dependence with psychoactive substance-induced psychotic disorder, unspecified ",
    value:
      "F19259 Other psychoactive substance dependence with psychoactive substance-induced psychotic disorder, unspecified ",
  },
  {
    label:
      "F1926 Other psychoactive substance dependence with psychoactive substance-induced persisting amnestic disorder ",
    value:
      "F1926 Other psychoactive substance dependence with psychoactive substance-induced persisting amnestic disorder ",
  },
  {
    label:
      "F1927 Other psychoactive substance dependence with psychoactive substance-induced persisting dementia ",
    value:
      "F1927 Other psychoactive substance dependence with psychoactive substance-induced persisting dementia ",
  },
  {
    label:
      "F19280 Other psychoactive substance dependence with psychoactive substance-induced anxiety disorder ",
    value:
      "F19280 Other psychoactive substance dependence with psychoactive substance-induced anxiety disorder ",
  },
  {
    label:
      "F19281 Other psychoactive substance dependence with psychoactive substance-induced sexual dysfunction ",
    value:
      "F19281 Other psychoactive substance dependence with psychoactive substance-induced sexual dysfunction ",
  },
  {
    label:
      "F19282 Other psychoactive substance dependence with psychoactive substance-induced sleep disorder ",
    value:
      "F19282 Other psychoactive substance dependence with psychoactive substance-induced sleep disorder ",
  },
  {
    label:
      "F19288 Other psychoactive substance dependence with other psychoactive substance-induced disorder ",
    value:
      "F19288 Other psychoactive substance dependence with other psychoactive substance-induced disorder ",
  },
  {
    label:
      "F1929 Other psychoactive substance dependence with unspecified psychoactive substance-induced disorder ",
    value:
      "F1929 Other psychoactive substance dependence with unspecified psychoactive substance-induced disorder ",
  },
  {
    label:
      "F1990 Other psychoactive substance use, unspecified, uncomplicated ",
    value:
      "F1990 Other psychoactive substance use, unspecified, uncomplicated ",
  },
  {
    label:
      "F19920 Other psychoactive substance use, unspecified with intoxication, uncomplicated F19921 Other psychoactive substance use, unspecified with intoxication with delirium ",
    value:
      "F19920 Other psychoactive substance use, unspecified with intoxication, uncomplicated F19921 Other psychoactive substance use, unspecified with intoxication with delirium ",
  },
  {
    label:
      "F19922 Other psychoactive substance use, unspecified with intoxication with perceptual disturbance ",
    value:
      "F19922 Other psychoactive substance use, unspecified with intoxication with perceptual disturbance ",
  },
  {
    label:
      "F19929 Other psychoactive substance use, unspecified with intoxication, unspecified ",
    value:
      "F19929 Other psychoactive substance use, unspecified with intoxication, unspecified ",
  },
  {
    label:
      "F19930 Other psychoactive substance use, unspecified with withdrawal, uncomplicated ",
    value:
      "F19930 Other psychoactive substance use, unspecified with withdrawal, uncomplicated ",
  },
  {
    label:
      "F19931 Other psychoactive substance use, unspecified with withdrawal delirium ",
    value:
      "F19931 Other psychoactive substance use, unspecified with withdrawal delirium ",
  },
  {
    label:
      "F19932 Other psychoactive substance use, unspecified with withdrawal with perceptual disturbance ",
    value:
      "F19932 Other psychoactive substance use, unspecified with withdrawal with perceptual disturbance ",
  },
  {
    label:
      "F19939 Other psychoactive substance use, unspecified with withdrawal, unspecified ",
    value:
      "F19939 Other psychoactive substance use, unspecified with withdrawal, unspecified ",
  },
  {
    label:
      "F1994 Other psychoactive substance use, unspecified with psychoactive substance-induced mood disorder ",
    value:
      "F1994 Other psychoactive substance use, unspecified with psychoactive substance-induced mood disorder ",
  },
  {
    label:
      "F19950 Other psychoactive substance use, unspecified with psychoactive substance-induced psychotic disorder with delusions ",
    value:
      "F19950 Other psychoactive substance use, unspecified with psychoactive substance-induced psychotic disorder with delusions ",
  },
  {
    label:
      "F19951 Other psychoactive substance use, unspecified with psychoactive substance-induced psychotic disorder with hallucinations ",
    value:
      "F19951 Other psychoactive substance use, unspecified with psychoactive substance-induced psychotic disorder with hallucinations ",
  },
  {
    label:
      "F19959 Other psychoactive substance use, unspecified with psychoactive substance-induced psychotic disorder, unspecified ",
    value:
      "F19959 Other psychoactive substance use, unspecified with psychoactive substance-induced psychotic disorder, unspecified ",
  },
  {
    label:
      "F1996 Other psychoactive substance use, unspecified with psychoactive substance-induced persisting amnestic disorder ",
    value:
      "F1996 Other psychoactive substance use, unspecified with psychoactive substance-induced persisting amnestic disorder ",
  },
  {
    label:
      "F1997 Other psychoactive substance use, unspecified with psychoactive substance-induced persisting dementia ",
    value:
      "F1997 Other psychoactive substance use, unspecified with psychoactive substance-induced persisting dementia ",
  },
  {
    label:
      "F19980 Other psychoactive substance use, unspecified with psychoactive substance-induced anxiety disorder ",
    value:
      "F19980 Other psychoactive substance use, unspecified with psychoactive substance-induced anxiety disorder ",
  },
  {
    label:
      "F19981 Other psychoactive substance use, unspecified with psychoactive substance-induced sexual dysfunction ",
    value:
      "F19981 Other psychoactive substance use, unspecified with psychoactive substance-induced sexual dysfunction ",
  },
  {
    label:
      "F19982 Other psychoactive substance use, unspecified with psychoactive substance-induced sleep disorder ",
    value:
      "F19982 Other psychoactive substance use, unspecified with psychoactive substance-induced sleep disorder ",
  },
  {
    label:
      "F19988 Other psychoactive substance use, unspecified with other psychoactive substance-induced disorder ",
    value:
      "F19988 Other psychoactive substance use, unspecified with other psychoactive substance-induced disorder ",
  },
  {
    label:
      "F1999 Other psychoactive substance use, unspecified with unspecified psychoactive substance-induced disorder ",
    value:
      "F1999 Other psychoactive substance use, unspecified with unspecified psychoactive substance-induced disorder ",
  },
  {
    label:
      "Schizophrenia, schizotypal, delusional, and other non-mood psychotic disorders (F20-F29)",
    value:
      "Schizophrenia, schizotypal, delusional, and other non-mood psychotic disorders (F20-F29)",
  },
  {
    label: "F200 Paranoid schizophrenia ",
    value: "F200 Paranoid schizophrenia ",
  },
  {
    label: "F201 Disorganized schizophrenia ",
    value: "F201 Disorganized schizophrenia ",
  },
  {
    label: "F202 Catatonic schizophrenia ",
    value: "F202 Catatonic schizophrenia ",
  },
  {
    label: "F203 Undifferentiated schizophrenia ",
    value: "F203 Undifferentiated schizophrenia ",
  },
  {
    label: "F205 Residual schizophrenia ",
    value: "F205 Residual schizophrenia ",
  },
  {
    label: "F2081 Schizophreniform disorder ",
    value: "F2081 Schizophreniform disorder ",
  },
  { label: "F2089 Other schizophrenia ", value: "F2089 Other schizophrenia " },
  {
    label: "F209 Schizophrenia, unspecified ",
    value: "F209 Schizophrenia, unspecified ",
  },
  { label: "F21 Schizotypal disorder ", value: "F21 Schizotypal disorder " },
  { label: "F22 Delusional disorders ", value: "F22 Delusional disorders " },
  {
    label: "F23 Brief psychotic disorder ",
    value: "F23 Brief psychotic disorder ",
  },
  {
    label: "F24 Shared psychotic disorder ",
    value: "F24 Shared psychotic disorder ",
  },
  {
    label: "F250 Schizoaffective disorder, bipolar type ",
    value: "F250 Schizoaffective disorder, bipolar type ",
  },
  {
    label: "F251 Schizoaffective disorder, depressive type ",
    value: "F251 Schizoaffective disorder, depressive type ",
  },
  {
    label: "F258 Other schizoaffective disorders ",
    value: "F258 Other schizoaffective disorders ",
  },
  {
    label: "F259 Schizoaffective disorder, unspecified ",
    value: "F259 Schizoaffective disorder, unspecified ",
  },
  {
    label:
      "F28 Other psychotic disorder not due to a substance or known physiological condition ",
    value:
      "F28 Other psychotic disorder not due to a substance or known physiological condition ",
  },
  {
    label:
      "F29 Unspecified psychosis not due to a substance or known physiological condition ",
    value:
      "F29 Unspecified psychosis not due to a substance or known physiological condition ",
  },
  {
    label: "Mood [affective] disorders (F30-F39)",
    value: "Mood [affective] disorders (F30-F39)",
  },
  {
    label: "F3010 Manic episode without psychotic symptoms, unspecified ",
    value: "F3010 Manic episode without psychotic symptoms, unspecified ",
  },
  {
    label: "F3011 Manic episode without psychotic symptoms, mild ",
    value: "F3011 Manic episode without psychotic symptoms, mild ",
  },
  {
    label: "F3012 Manic episode without psychotic symptoms, moderate ",
    value: "F3012 Manic episode without psychotic symptoms, moderate ",
  },
  {
    label: "F3013 Manic episode, severe, without psychotic symptoms ",
    value: "F3013 Manic episode, severe, without psychotic symptoms ",
  },
  {
    label: "F302 Manic episode, severe with psychotic symptoms ",
    value: "F302 Manic episode, severe with psychotic symptoms ",
  },
  {
    label: "F303 Manic episode in partial remission ",
    value: "F303 Manic episode in partial remission ",
  },
  {
    label: "F304 Manic episode in full remission ",
    value: "F304 Manic episode in full remission ",
  },
  { label: "F308 Other manic episodes ", value: "F308 Other manic episodes " },
  {
    label: "F309 Manic episode, unspecified ",
    value: "F309 Manic episode, unspecified ",
  },
  {
    label: "F310 Bipolar disorder, current episode hypomanic ",
    value: "F310 Bipolar disorder, current episode hypomanic ",
  },
  {
    label:
      "F3110 Bipolar disorder, current episode manic without psychotic features, unspecified ",
    value:
      "F3110 Bipolar disorder, current episode manic without psychotic features, unspecified ",
  },
  {
    label:
      "F3111 Bipolar disorder, current episode manic without psychotic features, mild ",
    value:
      "F3111 Bipolar disorder, current episode manic without psychotic features, mild ",
  },
  {
    label:
      "F3112 Bipolar disorder, current episode manic without psychotic features, moderate ",
    value:
      "F3112 Bipolar disorder, current episode manic without psychotic features, moderate ",
  },
  {
    label:
      "F3113 Bipolar disorder, current episode manic without psychotic features, severe ",
    value:
      "F3113 Bipolar disorder, current episode manic without psychotic features, severe ",
  },
  {
    label:
      "F312 Bipolar disorder, current episode manic severe with psychotic features ",
    value:
      "F312 Bipolar disorder, current episode manic severe with psychotic features ",
  },
  {
    label:
      "F3130 Bipolar disorder, current episode depressed, mild or moderate severity, unspecified F3131 Bipolar disorder, current episode depressed, mild ",
    value:
      "F3130 Bipolar disorder, current episode depressed, mild or moderate severity, unspecified F3131 Bipolar disorder, current episode depressed, mild ",
  },
  {
    label: "F3132 Bipolar disorder, current episode depressed, moderate ",
    value: "F3132 Bipolar disorder, current episode depressed, moderate ",
  },
  {
    label:
      "F314 Bipolar disorder, current episode depressed, severe, without psychotic features ",
    value:
      "F314 Bipolar disorder, current episode depressed, severe, without psychotic features ",
  },
  {
    label:
      "F315 Bipolar disorder, current episode depressed, severe, with psychotic features ",
    value:
      "F315 Bipolar disorder, current episode depressed, severe, with psychotic features ",
  },
  {
    label: "F3160 Bipolar disorder, current episode mixed, unspecified ",
    value: "F3160 Bipolar disorder, current episode mixed, unspecified ",
  },
  {
    label: "F3161 Bipolar disorder, current episode mixed, mild ",
    value: "F3161 Bipolar disorder, current episode mixed, mild ",
  },
  {
    label: "F3162 Bipolar disorder, current episode mixed, moderate ",
    value: "F3162 Bipolar disorder, current episode mixed, moderate ",
  },
  {
    label:
      "F3163 Bipolar disorder, current episode mixed, severe, without psychotic features ",
    value:
      "F3163 Bipolar disorder, current episode mixed, severe, without psychotic features ",
  },
  {
    label:
      "F3164 Bipolar disorder, current episode mixed, severe, with psychotic features ",
    value:
      "F3164 Bipolar disorder, current episode mixed, severe, with psychotic features ",
  },
  {
    label:
      "F3170 Bipolar disorder, currently in remission, most recent episode unspecified ",
    value:
      "F3170 Bipolar disorder, currently in remission, most recent episode unspecified ",
  },
  {
    label:
      "F3171 Bipolar disorder, in partial remission, most recent episode hypomanic ",
    value:
      "F3171 Bipolar disorder, in partial remission, most recent episode hypomanic ",
  },
  {
    label:
      "F3172 Bipolar disorder, in full remission, most recent episode hypomanic ",
    value:
      "F3172 Bipolar disorder, in full remission, most recent episode hypomanic ",
  },
  {
    label:
      "F3173 Bipolar disorder, in partial remission, most recent episode manic ",
    value:
      "F3173 Bipolar disorder, in partial remission, most recent episode manic ",
  },
  {
    label:
      "F3174 Bipolar disorder, in full remission, most recent episode manic ",
    value:
      "F3174 Bipolar disorder, in full remission, most recent episode manic ",
  },
  {
    label:
      "F3175 Bipolar disorder, in partial remission, most recent episode depressed ",
    value:
      "F3175 Bipolar disorder, in partial remission, most recent episode depressed ",
  },
  {
    label:
      "F3176 Bipolar disorder, in full remission, most recent episode depressed ",
    value:
      "F3176 Bipolar disorder, in full remission, most recent episode depressed ",
  },
  {
    label:
      "F3177 Bipolar disorder, in partial remission, most recent episode mixed ",
    value:
      "F3177 Bipolar disorder, in partial remission, most recent episode mixed ",
  },
  {
    label:
      "F3178 Bipolar disorder, in full remission, most recent episode mixed ",
    value:
      "F3178 Bipolar disorder, in full remission, most recent episode mixed ",
  },
  { label: "F3181 Bipolar II disorder ", value: "F3181 Bipolar II disorder " },
  {
    label: "F3189 Other bipolar disorder ",
    value: "F3189 Other bipolar disorder ",
  },
  {
    label: "F319 Bipolar disorder, unspecified ",
    value: "F319 Bipolar disorder, unspecified ",
  },
  {
    label: "F320 Major depressive disorder, single episode, mild ",
    value: "F320 Major depressive disorder, single episode, mild ",
  },
  {
    label: "F321 Major depressive disorder, single episode, moderate ",
    value: "F321 Major depressive disorder, single episode, moderate ",
  },
  {
    label:
      "F322 Major depressive disorder, single episode, severe without psychotic features ",
    value:
      "F322 Major depressive disorder, single episode, severe without psychotic features ",
  },
  {
    label:
      "F323 Major depressive disorder, single episode, severe with psychotic features ",
    value:
      "F323 Major depressive disorder, single episode, severe with psychotic features ",
  },
  {
    label:
      "F324 Major depressive disorder, single episode, in partial remission ",
    value:
      "F324 Major depressive disorder, single episode, in partial remission ",
  },
  {
    label: "F325 Major depressive disorder, single episode, in full remission ",
    value: "F325 Major depressive disorder, single episode, in full remission ",
  },
  {
    label: "F3281 Premenstrual dysphoric disorder ",
    value: "F3281 Premenstrual dysphoric disorder ",
  },
  {
    label: "F3289 Other specified depressive episodes ",
    value: "F3289 Other specified depressive episodes ",
  },
  {
    label: "F329 Major depressive disorder, single episode, unspecified ",
    value: "F329 Major depressive disorder, single episode, unspecified ",
  },
  {
    label: "F330 Major depressive disorder, recurrent, mild ",
    value: "F330 Major depressive disorder, recurrent, mild ",
  },
  {
    label: "F331 Major depressive disorder, recurrent, moderate ",
    value: "F331 Major depressive disorder, recurrent, moderate ",
  },
  {
    label:
      "F332 Major depressive disorder, recurrent severe without psychotic features ",
    value:
      "F332 Major depressive disorder, recurrent severe without psychotic features ",
  },
  {
    label:
      "F333 Major depressive disorder, recurrent, severe with psychotic symptoms ",
    value:
      "F333 Major depressive disorder, recurrent, severe with psychotic symptoms ",
  },
  {
    label:
      "F3340 Major depressive disorder, recurrent, in remission, unspecified ",
    value:
      "F3340 Major depressive disorder, recurrent, in remission, unspecified ",
  },
  {
    label: "F3341 Major depressive disorder, recurrent, in partial remission ",
    value: "F3341 Major depressive disorder, recurrent, in partial remission ",
  },
  {
    label: "F3342 Major depressive disorder, recurrent, in full remission ",
    value: "F3342 Major depressive disorder, recurrent, in full remission ",
  },
  {
    label: "F338 Other recurrent depressive disorders ",
    value: "F338 Other recurrent depressive disorders ",
  },
  {
    label: "F339 Major depressive disorder, recurrent, unspecified ",
    value: "F339 Major depressive disorder, recurrent, unspecified ",
  },
  { label: "F340 Cyclothymic disorder ", value: "F340 Cyclothymic disorder " },
  { label: "F341 Dysthymic disorder ", value: "F341 Dysthymic disorder " },
  {
    label: "F3481 Disruptive mood dysregulation disorder ",
    value: "F3481 Disruptive mood dysregulation disorder ",
  },
  {
    label: "F3489 Other specified persistent mood disorders ",
    value: "F3489 Other specified persistent mood disorders ",
  },
  {
    label: "F349 Persistent mood [affective] disorder, unspecified ",
    value: "F349 Persistent mood [affective] disorder, unspecified ",
  },
  {
    label: "F39 Unspecified mood [affective] disorder ",
    value: "F39 Unspecified mood [affective] disorder ",
  },
  {
    label:
      "Anxiety, dissociative, stress-related, somatoform and other nonpsychotic mental disorders (F40-F48)",
    value:
      "Anxiety, dissociative, stress-related, somatoform and other nonpsychotic mental disorders (F40-F48)",
  },
  {
    label: "F4000 Agoraphobia, unspecified ",
    value: "F4000 Agoraphobia, unspecified ",
  },
  {
    label: "F4001 Agoraphobia with panic disorder ",
    value: "F4001 Agoraphobia with panic disorder ",
  },
  {
    label: "F4002 Agoraphobia without panic disorder ",
    value: "F4002 Agoraphobia without panic disorder ",
  },
  {
    label: "F4010 Social phobia, unspecified ",
    value: "F4010 Social phobia, unspecified ",
  },
  {
    label: "F4011 Social phobia, generalized ",
    value: "F4011 Social phobia, generalized ",
  },
  { label: "F40210 Arachnophobia ", value: "F40210 Arachnophobia " },
  {
    label: "F40218 Other animal type phobia ",
    value: "F40218 Other animal type phobia ",
  },
  {
    label: "F40220 Fear of thunderstorms ",
    value: "F40220 Fear of thunderstorms ",
  },
  {
    label: "F40228 Other natural environment type phobia ",
    value: "F40228 Other natural environment type phobia ",
  },
  { label: "F40230 Fear of blood ", value: "F40230 Fear of blood " },
  {
    label: "F40231 Fear of injections and transfusions ",
    value: "F40231 Fear of injections and transfusions ",
  },
  {
    label: "F40232 Fear of other medical care ",
    value: "F40232 Fear of other medical care ",
  },
  { label: "F40233 Fear of injury ", value: "F40233 Fear of injury " },
  { label: "F40240 Claustrophobia ", value: "F40240 Claustrophobia " },
  { label: "F40241 Acrophobia ", value: "F40241 Acrophobia " },
  { label: "F40242 Fear of bridges ", value: "F40242 Fear of bridges " },
  { label: "F40243 Fear of flying ", value: "F40243 Fear of flying " },
  {
    label: "F40248 Other situational type phobia ",
    value: "F40248 Other situational type phobia ",
  },
  { label: "F40290 Androphobia ", value: "F40290 Androphobia " },
  { label: "F40291 Gynephobia ", value: "F40291 Gynephobia " },
  {
    label: "F40298 Other specified phobia ",
    value: "F40298 Other specified phobia ",
  },
  {
    label: "F408 Other phobic anxiety disorders ",
    value: "F408 Other phobic anxiety disorders ",
  },
  {
    label: "F409 Phobic anxiety disorder, unspecified ",
    value: "F409 Phobic anxiety disorder, unspecified ",
  },
  {
    label:
      "F410 Panic disorder [episodic paroxysmal anxiety] without agoraphobia ",
    value:
      "F410 Panic disorder [episodic paroxysmal anxiety] without agoraphobia ",
  },
  {
    label: "F411 Generalized anxiety disorder ",
    value: "F411 Generalized anxiety disorder ",
  },
  {
    label: "F413 Other mixed anxiety disorders ",
    value: "F413 Other mixed anxiety disorders ",
  },
  {
    label: "F418 Other specified anxiety disorders ",
    value: "F418 Other specified anxiety disorders ",
  },
  {
    label: "F419 Anxiety disorder, unspecified ",
    value: "F419 Anxiety disorder, unspecified ",
  },
  {
    label: "F422 Mixed obsessional thoughts and acts ",
    value: "F422 Mixed obsessional thoughts and acts ",
  },
  { label: "F423 Hoarding disorder ", value: "F423 Hoarding disorder " },
  {
    label: "F424 Excoriation (skin-picking) disorder ",
    value: "F424 Excoriation (skin-picking) disorder ",
  },
  {
    label: "F428 Other obsessive-compulsive disorder ",
    value: "F428 Other obsessive-compulsive disorder ",
  },
  {
    label: "F429 Obsessive-compulsive disorder, unspecified ",
    value: "F429 Obsessive-compulsive disorder, unspecified ",
  },
  {
    label: "F430 Acute stress reaction ",
    value: "F430 Acute stress reaction ",
  },
  {
    label: "F4310 Post-traumatic stress disorder, unspecified ",
    value: "F4310 Post-traumatic stress disorder, unspecified ",
  },
  {
    label: "F4311 Post-traumatic stress disorder, acute ",
    value: "F4311 Post-traumatic stress disorder, acute ",
  },
  {
    label: "F4312 Post-traumatic stress disorder, chronic ",
    value: "F4312 Post-traumatic stress disorder, chronic ",
  },
  {
    label: "F4320 Adjustment disorder, unspecified ",
    value: "F4320 Adjustment disorder, unspecified ",
  },
  {
    label: "F4321 Adjustment disorder with depressed mood ",
    value: "F4321 Adjustment disorder with depressed mood ",
  },
  {
    label: "F4322 Adjustment disorder with anxiety ",
    value: "F4322 Adjustment disorder with anxiety ",
  },
  {
    label: "F4323 Adjustment disorder with mixed anxiety and depressed mood ",
    value: "F4323 Adjustment disorder with mixed anxiety and depressed mood ",
  },
  {
    label: "F4324 Adjustment disorder with disturbance of conduct ",
    value: "F4324 Adjustment disorder with disturbance of conduct ",
  },
  {
    label:
      "F4325 Adjustment disorder with mixed disturbance of emotions and conduct ",
    value:
      "F4325 Adjustment disorder with mixed disturbance of emotions and conduct ",
  },
  {
    label: "F4329 Adjustment disorder with other symptoms ",
    value: "F4329 Adjustment disorder with other symptoms ",
  },
  {
    label: "F438 Other reactions to severe stress ",
    value: "F438 Other reactions to severe stress ",
  },
  {
    label: "F439 Reaction to severe stress, unspecified ",
    value: "F439 Reaction to severe stress, unspecified ",
  },
  { label: "F440 Dissociative amnesia ", value: "F440 Dissociative amnesia " },
  { label: "F441 Dissociative fugue ", value: "F441 Dissociative fugue " },
  { label: "F442 Dissociative stupor ", value: "F442 Dissociative stupor " },
  {
    label: "F444 Conversion disorder with motor symptom or deficit ",
    value: "F444 Conversion disorder with motor symptom or deficit ",
  },
  {
    label: "F445 Conversion disorder with seizures or convulsions ",
    value: "F445 Conversion disorder with seizures or convulsions ",
  },
  {
    label: "F446 Conversion disorder with sensory symptom or deficit ",
    value: "F446 Conversion disorder with sensory symptom or deficit ",
  },
  {
    label: "F447 Conversion disorder with mixed symptom presentation ",
    value: "F447 Conversion disorder with mixed symptom presentation ",
  },
  {
    label: "F4481 Dissociative identity disorder ",
    value: "F4481 Dissociative identity disorder ",
  },
  {
    label: "F4489 Other dissociative and conversion disorders ",
    value: "F4489 Other dissociative and conversion disorders ",
  },
  {
    label: "F449 Dissociative and conversion disorder, unspecified ",
    value: "F449 Dissociative and conversion disorder, unspecified ",
  },
  {
    label: "F450 Somatization disorder ",
    value: "F450 Somatization disorder ",
  },
  {
    label: "F451 Undifferentiated somatoform disorder ",
    value: "F451 Undifferentiated somatoform disorder ",
  },
  {
    label: "F4520 Hypochondriacal disorder, unspecified ",
    value: "F4520 Hypochondriacal disorder, unspecified ",
  },
  { label: "F4521 Hypochondriasis ", value: "F4521 Hypochondriasis " },
  {
    label: "F4522 Body dysmorphic disorder ",
    value: "F4522 Body dysmorphic disorder ",
  },
  {
    label: "F4529 Other hypochondriacal disorders ",
    value: "F4529 Other hypochondriacal disorders ",
  },
  {
    label: "F4541 Pain disorder exclusively related to psychological factors ",
    value: "F4541 Pain disorder exclusively related to psychological factors ",
  },
  {
    label: "F4542 Pain disorder with related psychological factors ",
    value: "F4542 Pain disorder with related psychological factors ",
  },
  {
    label: "F458 Other somatoform disorders ",
    value: "F458 Other somatoform disorders ",
  },
  {
    label: "F459 Somatoform disorder, unspecified ",
    value: "F459 Somatoform disorder, unspecified ",
  },
  {
    label: "F481 Depersonalization-derealization syndrome ",
    value: "F481 Depersonalization-derealization syndrome ",
  },
  { label: "F482 Pseudobulbar affect ", value: "F482 Pseudobulbar affect " },
  {
    label: "F488 Other specified nonpsychotic mental disorders ",
    value: "F488 Other specified nonpsychotic mental disorders ",
  },
  {
    label: "F489 Nonpsychotic mental disorder, unspecified ",
    value: "F489 Nonpsychotic mental disorder, unspecified ",
  },
  {
    label:
      "Behavioral syndromes associated with physiological disturbances and physical factors (F50-F59)",
    value:
      "Behavioral syndromes associated with physiological disturbances and physical factors (F50-F59)",
  },
  {
    label: "F5000 Anorexia nervosa, unspecified ",
    value: "F5000 Anorexia nervosa, unspecified ",
  },
  {
    label: "F5001 Anorexia nervosa, restricting type ",
    value: "F5001 Anorexia nervosa, restricting type ",
  },
  {
    label: "F5002 Anorexia nervosa, binge eating/purging type ",
    value: "F5002 Anorexia nervosa, binge eating/purging type ",
  },
  { label: "F502 Bulimia nervosa ", value: "F502 Bulimia nervosa " },
  {
    label: "F5081 Binge eating disorder ",
    value: "F5081 Binge eating disorder ",
  },
  {
    label: "F5089 Other specified eating disorder ",
    value: "F5089 Other specified eating disorder ",
  },
  {
    label: "F509 Eating disorder, unspecified ",
    value: "F509 Eating disorder, unspecified ",
  },
  { label: "F5101 Primary insomnia ", value: "F5101 Primary insomnia " },
  { label: "F5102 Adjustment insomnia ", value: "F5102 Adjustment insomnia " },
  {
    label: "F5103 Paradoxical insomnia ",
    value: "F5103 Paradoxical insomnia ",
  },
  {
    label: "F5104 Psychophysiologic insomnia ",
    value: "F5104 Psychophysiologic insomnia ",
  },
  {
    label: "F5105 Insomnia due to other mental disorder ",
    value: "F5105 Insomnia due to other mental disorder ",
  },
  {
    label:
      "F5109 Other insomnia not due to a substance or known physiological condition ",
    value:
      "F5109 Other insomnia not due to a substance or known physiological condition ",
  },
  { label: "F5111 Primary hypersomnia ", value: "F5111 Primary hypersomnia " },
  {
    label: "F5112 Insufficient sleep syndrome ",
    value: "F5112 Insufficient sleep syndrome ",
  },
  {
    label: "F5113 Hypersomnia due to other mental disorder ",
    value: "F5113 Hypersomnia due to other mental disorder ",
  },
  {
    label:
      "F5119 Other hypersomnia not due to a substance or known physiological condition ",
    value:
      "F5119 Other hypersomnia not due to a substance or known physiological condition ",
  },
  {
    label: "F513 Sleepwalking [somnambulism] ",
    value: "F513 Sleepwalking [somnambulism] ",
  },
  {
    label: "F514 Sleep terrors [night terrors] ",
    value: "F514 Sleep terrors [night terrors] ",
  },
  { label: "F515 Nightmare disorder ", value: "F515 Nightmare disorder " },
  {
    label:
      "F518 Other sleep disorders not due to a substance or known physiological condition ",
    value:
      "F518 Other sleep disorders not due to a substance or known physiological condition ",
  },
  {
    label:
      "F519 Sleep disorder not due to a substance or known physiological condition, unspecified ",
    value:
      "F519 Sleep disorder not due to a substance or known physiological condition, unspecified ",
  },
  {
    label: "F520 Hypoactive sexual desire disorder ",
    value: "F520 Hypoactive sexual desire disorder ",
  },
  {
    label: "F521 Sexual aversion disorder ",
    value: "F521 Sexual aversion disorder ",
  },
  {
    label: "F5221 Male erectile disorder ",
    value: "F5221 Male erectile disorder ",
  },
  {
    label: "F5222 Female sexual arousal disorder ",
    value: "F5222 Female sexual arousal disorder ",
  },
  {
    label: "F5231 Female orgasmic disorder ",
    value: "F5231 Female orgasmic disorder ",
  },
  {
    label: "F5232 Male orgasmic disorder ",
    value: "F5232 Male orgasmic disorder ",
  },
  {
    label: "F524 Premature ejaculation ",
    value: "F524 Premature ejaculation ",
  },
  {
    label:
      "F525 Vaginismus not due to a substance or known physiological condition ",
    value:
      "F525 Vaginismus not due to a substance or known physiological condition ",
  },
  {
    label:
      "F526 Dyspareunia not due to a substance or known physiological condition ",
    value:
      "F526 Dyspareunia not due to a substance or known physiological condition ",
  },
  {
    label:
      "F528 Other sexual dysfunction not due to a substance or known physiological condition ",
    value:
      "F528 Other sexual dysfunction not due to a substance or known physiological condition ",
  },
  {
    label:
      "F529 Unspecified sexual dysfunction not due to a substance or known physiological condition F53 Puerperal psychosis ",
    value:
      "F529 Unspecified sexual dysfunction not due to a substance or known physiological condition F53 Puerperal psychosis ",
  },
  {
    label:
      "F54 Psychological and behavioral factors associated with disorders or diseases classified elsewhere ",
    value:
      "F54 Psychological and behavioral factors associated with disorders or diseases classified elsewhere ",
  },
  { label: "F550 Abuse of antacids ", value: "F550 Abuse of antacids " },
  {
    label: "F551 Abuse of herbal or folk remedies ",
    value: "F551 Abuse of herbal or folk remedies ",
  },
  { label: "F552 Abuse of laxatives ", value: "F552 Abuse of laxatives " },
  {
    label: "F553 Abuse of steroids or hormones ",
    value: "F553 Abuse of steroids or hormones ",
  },
  { label: "F554 Abuse of vitamins ", value: "F554 Abuse of vitamins " },
  {
    label: "F558 Abuse of other non-psychoactive substances ",
    value: "F558 Abuse of other non-psychoactive substances ",
  },
  {
    label:
      "F59 Unspecified behavioral syndromes associated with physiological disturbances and physical factors ",
    value:
      "F59 Unspecified behavioral syndromes associated with physiological disturbances and physical factors ",
  },
  {
    label: "Disorders of adult personality and behavior (F60-F69)",
    value: "Disorders of adult personality and behavior (F60-F69)",
  },
  {
    label: "F600 Paranoid personality disorder ",
    value: "F600 Paranoid personality disorder ",
  },
  {
    label: "F601 Schizoid personality disorder ",
    value: "F601 Schizoid personality disorder ",
  },
  {
    label: "F602 Antisocial personality disorder ",
    value: "F602 Antisocial personality disorder ",
  },
  {
    label: "F603 Borderline personality disorder ",
    value: "F603 Borderline personality disorder ",
  },
  {
    label: "F604 Histrionic personality disorder ",
    value: "F604 Histrionic personality disorder ",
  },
  {
    label: "F605 Obsessive-compulsive personality disorder ",
    value: "F605 Obsessive-compulsive personality disorder ",
  },
  {
    label: "F606 Avoidant personality disorder ",
    value: "F606 Avoidant personality disorder ",
  },
  {
    label: "F607 Dependent personality disorder ",
    value: "F607 Dependent personality disorder ",
  },
  {
    label: "F6081 Narcissistic personality disorder ",
    value: "F6081 Narcissistic personality disorder ",
  },
  {
    label: "F6089 Other specific personality disorders ",
    value: "F6089 Other specific personality disorders ",
  },
  {
    label: "F609 Personality disorder, unspecified ",
    value: "F609 Personality disorder, unspecified ",
  },
  {
    label: "F630 Pathological gambling ",
    value: "F630 Pathological gambling ",
  },
  { label: "F631 Pyromania ", value: "F631 Pyromania " },
  { label: "F632 Kleptomania ", value: "F632 Kleptomania " },
  { label: "F633 Trichotillomania ", value: "F633 Trichotillomania " },
  {
    label: "F6381 Intermittent explosive disorder ",
    value: "F6381 Intermittent explosive disorder ",
  },
  {
    label: "F6389 Other impulse disorders",
    value: "F6389 Other impulse disorders",
  },
  {
    label: "F639 Impulse disorder, unspecified ",
    value: "F639 Impulse disorder, unspecified ",
  },
  { label: "F640 Transsexualism ", value: "F640 Transsexualism " },
  {
    label: "F641 Dual role transvestism ",
    value: "F641 Dual role transvestism ",
  },
  {
    label: "F642 Gender identity disorder of childhood ",
    value: "F642 Gender identity disorder of childhood ",
  },
  {
    label: "F648 Other gender identity disorders ",
    value: "F648 Other gender identity disorders ",
  },
  {
    label: "F649 Gender identity disorder, unspecified ",
    value: "F649 Gender identity disorder, unspecified ",
  },
  { label: "F650 Fetishism ", value: "F650 Fetishism " },
  {
    label: "F651 Transvestic fetishism ",
    value: "F651 Transvestic fetishism ",
  },
  { label: "F652 Exhibitionism ", value: "F652 Exhibitionism " },
  { label: "F653 Voyeurism ", value: "F653 Voyeurism " },
  { label: "F654 Pedophilia ", value: "F654 Pedophilia " },
  {
    label: "F6550 Sadomasochism, unspecified ",
    value: "F6550 Sadomasochism, unspecified ",
  },
  { label: "F6551 Sexual masochism ", value: "F6551 Sexual masochism " },
  { label: "F6552 Sexual sadism F", value: "F6552 Sexual sadism F" },
  { label: "6581 Frotteurism ", value: "6581 Frotteurism " },
  { label: "F6589 Other paraphilias ", value: "F6589 Other paraphilias " },
  {
    label: "F659 Paraphilia, unspecified ",
    value: "F659 Paraphilia, unspecified ",
  },
  {
    label: "F66 Other sexual disorders ",
    value: "F66 Other sexual disorders ",
  },
  {
    label: "F6810 Factitious disorder, unspecified ",
    value: "F6810 Factitious disorder, unspecified ",
  },
  {
    label:
      "F6811 Factitious disorder with predominantly psychological signs and symptoms ",
    value:
      "F6811 Factitious disorder with predominantly psychological signs and symptoms ",
  },
  {
    label:
      "F6812 Factitious disorder with predominantly physical signs and symptoms ",
    value:
      "F6812 Factitious disorder with predominantly physical signs and symptoms ",
  },
  {
    label:
      "F6813 Factitious disorder with combined psychological and physical signs and symptoms ",
    value:
      "F6813 Factitious disorder with combined psychological and physical signs and symptoms ",
  },
  {
    label: "F688 Other specified disorders of adult personality and behavior ",
    value: "F688 Other specified disorders of adult personality and behavior ",
  },
  {
    label: "F69 Unspecified disorder of adult personality and behavior ",
    value: "F69 Unspecified disorder of adult personality and behavior ",
  },
  {
    label: "Intellectual disabilities (F70-F79)",
    value: "Intellectual disabilities (F70-F79)",
  },
  {
    label: "F70 Mild intellectual disabilities ",
    value: "F70 Mild intellectual disabilities ",
  },
  {
    label: "F71 Moderate intellectual disabilities ",
    value: "F71 Moderate intellectual disabilities ",
  },
  {
    label: "F72 Severe intellectual disabilities ",
    value: "F72 Severe intellectual disabilities ",
  },
  {
    label: "F73 Profound intellectual disabilities ",
    value: "F73 Profound intellectual disabilities ",
  },
  {
    label: "F78 Other intellectual disabilities ",
    value: "F78 Other intellectual disabilities ",
  },
  {
    label: "F79 Unspecified intellectual disabilities ",
    value: "F79 Unspecified intellectual disabilities ",
  },
  {
    label: "Pervasive and specific developmental disorders (F80-F89)",
    value: "Pervasive and specific developmental disorders (F80-F89)",
  },
  {
    label: "F800 Phonological disorder ",
    value: "F800 Phonological disorder ",
  },
  {
    label: "F801 Expressive language disorder ",
    value: "F801 Expressive language disorder ",
  },
  {
    label: "F802 Mixed receptive-expressive language disorder ",
    value: "F802 Mixed receptive-expressive language disorder ",
  },
  {
    label: "F804 Speech and language development delay due to hearing loss ",
    value: "F804 Speech and language development delay due to hearing loss ",
  },
  {
    label: "F8081 Childhood onset fluency disorder ",
    value: "F8081 Childhood onset fluency disorder ",
  },
  {
    label: "F8082 Social pragmatic communication disorder ",
    value: "F8082 Social pragmatic communication disorder ",
  },
  {
    label: "F8089 Other developmental disorders of speech and language ",
    value: "F8089 Other developmental disorders of speech and language ",
  },
  {
    label: "F809 Developmental disorder of speech and language, unspecified ",
    value: "F809 Developmental disorder of speech and language, unspecified ",
  },
  {
    label: "F810 Specific reading disorder ",
    value: "F810 Specific reading disorder ",
  },
  { label: "F812 Mathematics disorder ", value: "F812 Mathematics disorder " },
  {
    label: "F8181 Disorder of written expression ",
    value: "F8181 Disorder of written expression ",
  },
  {
    label: "F8189 Other developmental disorders of scholastic skills ",
    value: "F8189 Other developmental disorders of scholastic skills ",
  },
  {
    label: "F819 Developmental disorder of scholastic skills, unspecified ",
    value: "F819 Developmental disorder of scholastic skills, unspecified ",
  },
  {
    label: "F82 Specific developmental disorder of motor function ",
    value: "F82 Specific developmental disorder of motor function ",
  },
  { label: "F840 Autistic disorder ", value: "F840 Autistic disorder " },
  { label: "F842 Rett's syndrome ", value: "F842 Rett's syndrome " },
  {
    label: "F843 Other childhood disintegrative disorder ",
    value: "F843 Other childhood disintegrative disorder ",
  },
  { label: "F845 Asperger's syndrome ", value: "F845 Asperger's syndrome " },
  {
    label: "F848 Other pervasive developmental disorders ",
    value: "F848 Other pervasive developmental disorders ",
  },
  {
    label: "F849 Pervasive developmental disorder, unspecified ",
    value: "F849 Pervasive developmental disorder, unspecified ",
  },
  {
    label: "F88 Other disorders of psychological development ",
    value: "F88 Other disorders of psychological development ",
  },
  {
    label: "F89 Unspecified disorder of psychological development ",
    value: "F89 Unspecified disorder of psychological development ",
  },
  {
    label:
      "Behavioral and emotional disorders with onset usually occurring in childhood and adolescence (F90-F98)",
    value:
      "Behavioral and emotional disorders with onset usually occurring in childhood and adolescence (F90-F98)",
  },
  {
    label:
      "F900 Attention-deficit hyperactivity disorder, predominantly inattentive type ",
    value:
      "F900 Attention-deficit hyperactivity disorder, predominantly inattentive type ",
  },
  {
    label:
      "F901 Attention-deficit hyperactivity disorder, predominantly hyperactive type ",
    value:
      "F901 Attention-deficit hyperactivity disorder, predominantly hyperactive type ",
  },
  {
    label: "F902 Attention-deficit hyperactivity disorder, combined type ",
    value: "F902 Attention-deficit hyperactivity disorder, combined type ",
  },
  {
    label: "F908 Attention-deficit hyperactivity disorder, other type ",
    value: "F908 Attention-deficit hyperactivity disorder, other type ",
  },
  {
    label: "F909 Attention-deficit hyperactivity disorder, unspecified type ",
    value: "F909 Attention-deficit hyperactivity disorder, unspecified type ",
  },
  {
    label: "F910 Conduct disorder confined to family context ",
    value: "F910 Conduct disorder confined to family context ",
  },
  {
    label: "F911 Conduct disorder, childhood-onset type ",
    value: "F911 Conduct disorder, childhood-onset type ",
  },
  {
    label: "F912 Conduct disorder, adolescent-onset type ",
    value: "F912 Conduct disorder, adolescent-onset type ",
  },
  {
    label: "F913 Oppositional defiant disorder ",
    value: "F913 Oppositional defiant disorder ",
  },
  {
    label: "F918 Other conduct disorders ",
    value: "F918 Other conduct disorders ",
  },
  {
    label: "F919 Conduct disorder, unspecified ",
    value: "F919 Conduct disorder, unspecified ",
  },
  {
    label: "F930 Separation anxiety disorder of childhood ",
    value: "F930 Separation anxiety disorder of childhood ",
  },
  {
    label: "F938 Other childhood emotional disorders ",
    value: "F938 Other childhood emotional disorders ",
  },
  {
    label: "F939 Childhood emotional disorder, unspecified ",
    value: "F939 Childhood emotional disorder, unspecified ",
  },
  { label: "F940 Selective mutism ", value: "F940 Selective mutism " },
  {
    label: "F941 Reactive attachment disorder of childhood ",
    value: "F941 Reactive attachment disorder of childhood ",
  },
  {
    label: "F942 Disinhibited attachment disorder of childhood ",
    value: "F942 Disinhibited attachment disorder of childhood ",
  },
  {
    label: "F948 Other childhood disorders of social functioning ",
    value: "F948 Other childhood disorders of social functioning ",
  },
  {
    label: "F949 Childhood disorder of social functioning, unspecified ",
    value: "F949 Childhood disorder of social functioning, unspecified ",
  },
  {
    label: "F950 Transient tic disorder ",
    value: "F950 Transient tic disorder ",
  },
  {
    label: "F951 Chronic motor or vocal tic disorder ",
    value: "F951 Chronic motor or vocal tic disorder ",
  },
  {
    label: "F952 Tourette's disorder F958 Other tic disorders ",
    value: "F952 Tourette's disorder F958 Other tic disorders ",
  },
  {
    label: "F959 Tic disorder, unspecified ",
    value: "F959 Tic disorder, unspecified ",
  },
  {
    label:
      "F980 Enuresis not due to a substance or known physiological condition ",
    value:
      "F980 Enuresis not due to a substance or known physiological condition ",
  },
  {
    label:
      "F981 Encopresis not due to a substance or known physiological condition ",
    value:
      "F981 Encopresis not due to a substance or known physiological condition ",
  },
  {
    label: "F9821 Rumination disorder of infancy ",
    value: "F9821 Rumination disorder of infancy ",
  },
  {
    label: "F9829 Other feeding disorders of infancy and early childhood ",
    value: "F9829 Other feeding disorders of infancy and early childhood ",
  },
  {
    label: "F983 Pica of infancy and childhood ",
    value: "F983 Pica of infancy and childhood ",
  },
  {
    label: "F984 Stereotyped movement disorders ",
    value: "F984 Stereotyped movement disorders ",
  },
  {
    label: "F985 Adult onset fluency disorder ",
    value: "F985 Adult onset fluency disorder ",
  },
  {
    label:
      "F988 Other specified behavioral and emotional disorders with onset usually occurring in childhood and adolescence ",
    value:
      "F988 Other specified behavioral and emotional disorders with onset usually occurring in childhood and adolescence ",
  },
  {
    label:
      "F989 Unspecified behavioral and emotional disorders with onset usually occurring in childhood and adolescence ",
    value:
      "F989 Unspecified behavioral and emotional disorders with onset usually occurring in childhood and adolescence ",
  },
  {
    label: "Unspecified mental disorder (F99)",
    value: "Unspecified mental disorder (F99)",
  },
  {
    label: "F99 Mental disorder, not otherwise specified",
    value: "F99 Mental disorder, not otherwise specified",
  },
];

export const dummyChatPatients = [
  {
    name: "Tobi Yurighan",
    risk: "urgent",
    date: "06/03/23",
    preview: "Sent you a pinned...",
    count: 4,
  },
  {
    name: "Ted Lasso",
    risk: "urgent",
    date: "05/02/23",
    preview: "Needs your attention...",
    count: 2,
  },
  {
    name: "Drew Harper",
    risk: "medium",
    date: "03/02/23",
    preview: "Requested a meeting...",
    count: 6,
  },
  {
    name: "Liam Patel",
    risk: "low",
    date: "28/01/23",
    preview: "Sent you a message...",
    count: 5,
  },
  {
    name: "Ashley Nguyen",
    risk: "medium",
    date: "24/01/23",
    preview: "New document shared...",
    count: 3,
  },
  {
    name: "Ella Kim",
    risk: "urgent",
    date: "21/01/23",
    preview: "Sent you an urgent...",
    count: 5,
  },
  {
    name: "Javier Rodriguez",
    risk: "low",
    date: "16/01/23",
    preview: "Sent you a video...",
    count: 5,
  },
  {
    name: "Nina Gupta",
    risk: "urgent",
    date: "11/01/23",
    preview: "Sent you a pinned...",
    count: 6,
  },
  {
    name: "Maxwell Wu",
    risk: "medium",
    date: "08/01/23",
    preview: "Sent you a file...",
    count: 2,
  },
  {
    name: "Leah Johnson",
    risk: "low",
    date: "02/01/23",
    preview: "Sent you a message...",
    count: 5,
  },
];

export const dummyPatientNotes = [
  {
    date: "Jan 23, 2023",
    diagnosis: "Geriatric Anxiety unspecified (F4320)",
    notes:
      "Provided a safe and supportive environment for the client to share their feelings and experiences openly. Validated their emotions and concerns to create a strong therapeutic alliance.",
  },
  {
    date: "Mar 12, 2023",
    diagnosis: "Geriatric Depression unspecified (F3310)",
    notes:
      "Implemented cognitive-behavioral therapy techniques to challenge negative thought patterns and improve mood. Collaborated with the client to develop coping strategies for managing depressive symptoms.",
  },
  {
    date: "Jun 15, 2023",
    diagnosis: "Adjustment Disorder with Anxiety (F4321)",
    notes:
      "Utilized mindfulness-based techniques to help the client identify and manage triggers for anxiety. Provided psychoeducation on stress management and relaxation techniques.",
  },
  {
    date: "Aug 1, 2023",
    diagnosis: "Post-Traumatic Stress Disorder (PTSD) (F4311)",
    notes:
      "Implemented trauma-focused cognitive-behavioral therapy to address and process past traumatic experiences. Assisted the client in developing healthy coping mechanisms for managing PTSD symptoms.",
  },
  {
    date: "Oct 5, 2023",
    diagnosis: "Major Depressive Disorder (F3200)",
    notes:
      "Conducted a comprehensive assessment to identify the severity and duration of depressive symptoms. Collaborated with the client to develop a personalized treatment plan, including medication and therapy.",
  },
  {
    date: "Jan 30, 2024",
    diagnosis: "Generalized Anxiety Disorder (F4110)",
    notes:
      "Implemented exposure therapy techniques to help the client confront and manage their anxiety triggers. Assisted the client in developing effective coping skills to reduce anxiety symptoms.",
  },
  {
    date: "Feb 15, 2024",
    diagnosis: "Bipolar Disorder Type I (F3100)",
    notes:
      "Provided psychoeducation on bipolar disorder, including mood tracking and symptom management. Collaborated with the client's psychiatrist to adjust medication regimen for mood stabilization.",
  },
  {
    date: "Nov 20, 2024",
    diagnosis: "Schizophrenia (F2000)",
    notes:
      "Implemented a multi-modal treatment approach, including medication management, individual therapy, and psychoeducation for the client and their family. Assisted the client in developing coping strategies for managing symptoms.",
  },
  {
    date: "Dec 7, 2024",
    diagnosis: "Obsessive-Compulsive Disorder (OCD) (F4200)",
    notes:
      "Conducted exposure and response prevention (ERP) therapy to help the client confront and manage their OCD symptoms. Collaborated with the client to develop healthy coping mechanisms for managing obsessive thoughts and compulsive behaviors.",
  },
  {
    date: "Jan 23, 2023",
    diagnosis: "Geriatric Anxiety unspecified (F4320)",
    notes:
      "Provided a safe and supportive environment for the client to share their feelings and experiences openly. Validated their emotions and concerns to create a strong therapeutic alliance.",
  },
  {
    date: "Mar 12, 2023",
    diagnosis: "Geriatric Depression unspecified (F3310)",
    notes:
      "Implemented cognitive-behavioral therapy techniques to challenge negative thought patterns and improve mood. Collaborated with the client to develop coping strategies for managing depressive symptoms.",
  },
  {
    date: "Jun 15, 2023",
    diagnosis: "Adjustment Disorder with Anxiety (F4321)",
    notes:
      "Utilized mindfulness-based techniques to help the client identify and manage triggers for anxiety. Provided psychoeducation on stress management and relaxation techniques.",
  },
  {
    date: "Aug 1, 2023",
    diagnosis: "Post-Traumatic Stress Disorder (PTSD) (F4311)",
    notes:
      "Implemented trauma-focused cognitive-behavioral therapy to address and process past traumatic experiences. Assisted the client in developing healthy coping mechanisms for managing PTSD symptoms.",
  },
  {
    date: "Oct 5, 2023",
    diagnosis: "Major Depressive Disorder (F3200)",
    notes:
      "Conducted a comprehensive assessment to identify the severity and duration of depressive symptoms. Collaborated with the client to develop a personalized treatment plan, including medication and therapy.",
  },
  {
    date: "Jan 30, 2024",
    diagnosis: "Generalized Anxiety Disorder (F4110)",
    notes:
      "Implemented exposure therapy techniques to help the client confront and manage their anxiety triggers. Assisted the client in developing effective coping skills to reduce anxiety symptoms.",
  },
  {
    date: "Feb 15, 2024",
    diagnosis: "Bipolar Disorder Type I (F3100)",
    notes:
      "Provided psychoeducation on bipolar disorder, including mood tracking and symptom management. Collaborated with the client's psychiatrist to adjust medication regimen for mood stabilization.",
  },
  {
    date: "Nov 20, 2024",
    diagnosis: "Schizophrenia (F2000)",
    notes:
      "Implemented a multi-modal treatment approach, including medication management, individual therapy, and psychoeducation for the client and their family. Assisted the client in developing coping strategies for managing symptoms.",
  },
  {
    date: "Dec 7, 2024",
    diagnosis: "Obsessive-Compulsive Disorder (OCD) (F4200)",
    notes:
      "Conducted exposure and response prevention (ERP) therapy to help the client confront and manage their OCD symptoms. Collaborated with the client to develop healthy coping mechanisms for managing obsessive thoughts and compulsive behaviors.",
  },
  {
    date: "Jan 23, 2023",
    diagnosis: "Geriatric Anxiety unspecified (F4320)",
    notes:
      "Provided a safe and supportive environment for the client to share their feelings and experiences openly. Validated their emotions and concerns to create a strong therapeutic alliance.",
  },
  {
    date: "Mar 12, 2023",
    diagnosis: "Geriatric Depression unspecified (F3310)",
    notes:
      "Implemented cognitive-behavioral therapy techniques to challenge negative thought patterns and improve mood. Collaborated with the client to develop coping strategies for managing depressive symptoms.",
  },
  {
    date: "Jun 15, 2023",
    diagnosis: "Adjustment Disorder with Anxiety (F4321)",
    notes:
      "Utilized mindfulness-based techniques to help the client identify and manage triggers for anxiety. Provided psychoeducation on stress management and relaxation techniques.",
  },
  {
    date: "Aug 1, 2023",
    diagnosis: "Post-Traumatic Stress Disorder (PTSD) (F4311)",
    notes:
      "Implemented trauma-focused cognitive-behavioral therapy to address and process past traumatic experiences. Assisted the client in developing healthy coping mechanisms for managing PTSD symptoms.",
  },
  {
    date: "Oct 5, 2023",
    diagnosis: "Major Depressive Disorder (F3200)",
    notes:
      "Conducted a comprehensive assessment to identify the severity and duration of depressive symptoms. Collaborated with the client to develop a personalized treatment plan, including medication and therapy.",
  },
  {
    date: "Jan 30, 2024",
    diagnosis: "Generalized Anxiety Disorder (F4110)",
    notes:
      "Implemented exposure therapy techniques to help the client confront and manage their anxiety triggers. Assisted the client in developing effective coping skills to reduce anxiety symptoms.",
  },
  {
    date: "Feb 15, 2024",
    diagnosis: "Bipolar Disorder Type I (F3100)",
    notes:
      "Provided psychoeducation on bipolar disorder, including mood tracking and symptom management. Collaborated with the client's psychiatrist to adjust medication regimen for mood stabilization.",
  },
  {
    date: "Nov 20, 2024",
    diagnosis: "Schizophrenia (F2000)",
    notes:
      "Implemented a multi-modal treatment approach, including medication management, individual therapy, and psychoeducation for the client and their family. Assisted the client in developing coping strategies for managing symptoms.",
  },
  {
    date: "Dec 7, 2024",
    diagnosis: "Obsessive-Compulsive Disorder (OCD) (F4200)",
    notes:
      "Conducted exposure and response prevention (ERP) therapy to help the client confront and manage their OCD symptoms. Collaborated with the client to develop healthy coping mechanisms for managing obsessive thoughts and compulsive behaviors.",
  },
  {
    date: "Jan 23, 2023",
    diagnosis: "Geriatric Anxiety unspecified (F4320)",
    notes:
      "Provided a safe and supportive environment for the client to share their feelings and experiences openly. Validated their emotions and concerns to create a strong therapeutic alliance.",
  },
  {
    date: "Mar 12, 2023",
    diagnosis: "Geriatric Depression unspecified (F3310)",
    notes:
      "Implemented cognitive-behavioral therapy techniques to challenge negative thought patterns and improve mood. Collaborated with the client to develop coping strategies for managing depressive symptoms.",
  },
  {
    date: "Jun 15, 2023",
    diagnosis: "Adjustment Disorder with Anxiety (F4321)",
    notes:
      "Utilized mindfulness-based techniques to help the client identify and manage triggers for anxiety. Provided psychoeducation on stress management and relaxation techniques.",
  },
  {
    date: "Aug 1, 2023",
    diagnosis: "Post-Traumatic Stress Disorder (PTSD) (F4311)",
    notes:
      "Implemented trauma-focused cognitive-behavioral therapy to address and process past traumatic experiences. Assisted the client in developing healthy coping mechanisms for managing PTSD symptoms.",
  },
  {
    date: "Oct 5, 2023",
    diagnosis: "Major Depressive Disorder (F3200)",
    notes:
      "Conducted a comprehensive assessment to identify the severity and duration of depressive symptoms. Collaborated with the client to develop a personalized treatment plan, including medication and therapy.",
  },
  {
    date: "Jan 30, 2024",
    diagnosis: "Generalized Anxiety Disorder (F4110)",
    notes:
      "Implemented exposure therapy techniques to help the client confront and manage their anxiety triggers. Assisted the client in developing effective coping skills to reduce anxiety symptoms.",
  },
  {
    date: "Feb 15, 2024",
    diagnosis: "Bipolar Disorder Type I (F3100)",
    notes:
      "Provided psychoeducation on bipolar disorder, including mood tracking and symptom management. Collaborated with the client's psychiatrist to adjust medication regimen for mood stabilization.",
  },
  {
    date: "Nov 20, 2024",
    diagnosis: "Schizophrenia (F2000)",
    notes:
      "Implemented a multi-modal treatment approach, including medication management, individual therapy, and psychoeducation for the client and their family. Assisted the client in developing coping strategies for managing symptoms.",
  },
  {
    date: "Dec 7, 2024",
    diagnosis: "Obsessive-Compulsive Disorder (OCD) (F4200)",
    notes:
      "Conducted exposure and response prevention (ERP) therapy to help the client confront and manage their OCD symptoms. Collaborated with the client to develop healthy coping mechanisms for managing obsessive thoughts and compulsive behaviors.",
  },
  {
    date: "Jan 23, 2023",
    diagnosis: "Geriatric Anxiety unspecified (F4320)",
    notes:
      "Provided a safe and supportive environment for the client to share their feelings and experiences openly. Validated their emotions and concerns to create a strong therapeutic alliance.",
  },
  {
    date: "Mar 12, 2023",
    diagnosis: "Geriatric Depression unspecified (F3310)",
    notes:
      "Implemented cognitive-behavioral therapy techniques to challenge negative thought patterns and improve mood. Collaborated with the client to develop coping strategies for managing depressive symptoms.",
  },
  {
    date: "Jun 15, 2023",
    diagnosis: "Adjustment Disorder with Anxiety (F4321)",
    notes:
      "Utilized mindfulness-based techniques to help the client identify and manage triggers for anxiety. Provided psychoeducation on stress management and relaxation techniques.",
  },
  {
    date: "Aug 1, 2023",
    diagnosis: "Post-Traumatic Stress Disorder (PTSD) (F4311)",
    notes:
      "Implemented trauma-focused cognitive-behavioral therapy to address and process past traumatic experiences. Assisted the client in developing healthy coping mechanisms for managing PTSD symptoms.",
  },
  {
    date: "Oct 5, 2023",
    diagnosis: "Major Depressive Disorder (F3200)",
    notes:
      "Conducted a comprehensive assessment to identify the severity and duration of depressive symptoms. Collaborated with the client to develop a personalized treatment plan, including medication and therapy.",
  },
  {
    date: "Jan 30, 2024",
    diagnosis: "Generalized Anxiety Disorder (F4110)",
    notes:
      "Implemented exposure therapy techniques to help the client confront and manage their anxiety triggers. Assisted the client in developing effective coping skills to reduce anxiety symptoms.",
  },
  {
    date: "Feb 15, 2024",
    diagnosis: "Bipolar Disorder Type I (F3100)",
    notes:
      "Provided psychoeducation on bipolar disorder, including mood tracking and symptom management. Collaborated with the client's psychiatrist to adjust medication regimen for mood stabilization.",
  },
  {
    date: "Nov 20, 2024",
    diagnosis: "Schizophrenia (F2000)",
    notes:
      "Implemented a multi-modal treatment approach, including medication management, individual therapy, and psychoeducation for the client and their family. Assisted the client in developing coping strategies for managing symptoms.",
  },
  {
    date: "Dec 7, 2024",
    diagnosis: "Obsessive-Compulsive Disorder (OCD) (F4200)",
    notes:
      "Conducted exposure and response prevention (ERP) therapy to help the client confront and manage their OCD symptoms. Collaborated with the client to develop healthy coping mechanisms for managing obsessive thoughts and compulsive behaviors.",
  },
  {
    date: "Jan 23, 2023",
    diagnosis: "Geriatric Anxiety unspecified (F4320)",
    notes:
      "Provided a safe and supportive environment for the client to share their feelings and experiences openly. Validated their emotions and concerns to create a strong therapeutic alliance.",
  },
  {
    date: "Mar 12, 2023",
    diagnosis: "Geriatric Depression unspecified (F3310)",
    notes:
      "Implemented cognitive-behavioral therapy techniques to challenge negative thought patterns and improve mood. Collaborated with the client to develop coping strategies for managing depressive symptoms.",
  },
  {
    date: "Jun 15, 2023",
    diagnosis: "Adjustment Disorder with Anxiety (F4321)",
    notes:
      "Utilized mindfulness-based techniques to help the client identify and manage triggers for anxiety. Provided psychoeducation on stress management and relaxation techniques.",
  },
  {
    date: "Aug 1, 2023",
    diagnosis: "Post-Traumatic Stress Disorder (PTSD) (F4311)",
    notes:
      "Implemented trauma-focused cognitive-behavioral therapy to address and process past traumatic experiences. Assisted the client in developing healthy coping mechanisms for managing PTSD symptoms.",
  },
  {
    date: "Oct 5, 2023",
    diagnosis: "Major Depressive Disorder (F3200)",
    notes:
      "Conducted a comprehensive assessment to identify the severity and duration of depressive symptoms. Collaborated with the client to develop a personalized treatment plan, including medication and therapy.",
  },
  {
    date: "Jan 30, 2024",
    diagnosis: "Generalized Anxiety Disorder (F4110)",
    notes:
      "Implemented exposure therapy techniques to help the client confront and manage their anxiety triggers. Assisted the client in developing effective coping skills to reduce anxiety symptoms.",
  },
  {
    date: "Feb 15, 2024",
    diagnosis: "Bipolar Disorder Type I (F3100)",
    notes:
      "Provided psychoeducation on bipolar disorder, including mood tracking and symptom management. Collaborated with the client's psychiatrist to adjust medication regimen for mood stabilization.",
  },
  {
    date: "Nov 20, 2024",
    diagnosis: "Schizophrenia (F2000)",
    notes:
      "Implemented a multi-modal treatment approach, including medication management, individual therapy, and psychoeducation for the client and their family. Assisted the client in developing coping strategies for managing symptoms.",
  },
  {
    date: "Dec 7, 2024",
    diagnosis: "Obsessive-Compulsive Disorder (OCD) (F4200)",
    notes:
      "Conducted exposure and response prevention (ERP) therapy to help the client confront and manage their OCD symptoms. Collaborated with the client to develop healthy coping mechanisms for managing obsessive thoughts and compulsive behaviors.",
  },
  {
    date: "Jan 23, 2023",
    diagnosis: "Geriatric Anxiety unspecified (F4320)",
    notes:
      "Provided a safe and supportive environment for the client to share their feelings and experiences openly. Validated their emotions and concerns to create a strong therapeutic alliance.",
  },
  {
    date: "Mar 12, 2023",
    diagnosis: "Geriatric Depression unspecified (F3310)",
    notes:
      "Implemented cognitive-behavioral therapy techniques to challenge negative thought patterns and improve mood. Collaborated with the client to develop coping strategies for managing depressive symptoms.",
  },
  {
    date: "Jun 15, 2023",
    diagnosis: "Adjustment Disorder with Anxiety (F4321)",
    notes:
      "Utilized mindfulness-based techniques to help the client identify and manage triggers for anxiety. Provided psychoeducation on stress management and relaxation techniques.",
  },
  {
    date: "Aug 1, 2023",
    diagnosis: "Post-Traumatic Stress Disorder (PTSD) (F4311)",
    notes:
      "Implemented trauma-focused cognitive-behavioral therapy to address and process past traumatic experiences. Assisted the client in developing healthy coping mechanisms for managing PTSD symptoms.",
  },
  {
    date: "Oct 5, 2023",
    diagnosis: "Major Depressive Disorder (F3200)",
    notes:
      "Conducted a comprehensive assessment to identify the severity and duration of depressive symptoms. Collaborated with the client to develop a personalized treatment plan, including medication and therapy.",
  },
  {
    date: "Jan 30, 2024",
    diagnosis: "Generalized Anxiety Disorder (F4110)",
    notes:
      "Implemented exposure therapy techniques to help the client confront and manage their anxiety triggers. Assisted the client in developing effective coping skills to reduce anxiety symptoms.",
  },
  {
    date: "Feb 15, 2024",
    diagnosis: "Bipolar Disorder Type I (F3100)",
    notes:
      "Provided psychoeducation on bipolar disorder, including mood tracking and symptom management. Collaborated with the client's psychiatrist to adjust medication regimen for mood stabilization.",
  },
  {
    date: "Nov 20, 2024",
    diagnosis: "Schizophrenia (F2000)",
    notes:
      "Implemented a multi-modal treatment approach, including medication management, individual therapy, and psychoeducation for the client and their family. Assisted the client in developing coping strategies for managing symptoms.",
  },
  {
    date: "Dec 7, 2024",
    diagnosis: "Obsessive-Compulsive Disorder (OCD) (F4200)",
    notes:
      "Conducted exposure and response prevention (ERP) therapy to help the client confront and manage their OCD symptoms. Collaborated with the client to develop healthy coping mechanisms for managing obsessive thoughts and compulsive behaviors.",
  },
  {
    date: "Jan 23, 2023",
    diagnosis: "Geriatric Anxiety unspecified (F4320)",
    notes:
      "Provided a safe and supportive environment for the client to share their feelings and experiences openly. Validated their emotions and concerns to create a strong therapeutic alliance.",
  },
  {
    date: "Mar 12, 2023",
    diagnosis: "Geriatric Depression unspecified (F3310)",
    notes:
      "Implemented cognitive-behavioral therapy techniques to challenge negative thought patterns and improve mood. Collaborated with the client to develop coping strategies for managing depressive symptoms.",
  },
  {
    date: "Jun 15, 2023",
    diagnosis: "Adjustment Disorder with Anxiety (F4321)",
    notes:
      "Utilized mindfulness-based techniques to help the client identify and manage triggers for anxiety. Provided psychoeducation on stress management and relaxation techniques.",
  },
  {
    date: "Aug 1, 2023",
    diagnosis: "Post-Traumatic Stress Disorder (PTSD) (F4311)",
    notes:
      "Implemented trauma-focused cognitive-behavioral therapy to address and process past traumatic experiences. Assisted the client in developing healthy coping mechanisms for managing PTSD symptoms.",
  },
  {
    date: "Oct 5, 2023",
    diagnosis: "Major Depressive Disorder (F3200)",
    notes:
      "Conducted a comprehensive assessment to identify the severity and duration of depressive symptoms. Collaborated with the client to develop a personalized treatment plan, including medication and therapy.",
  },
  {
    date: "Jan 30, 2024",
    diagnosis: "Generalized Anxiety Disorder (F4110)",
    notes:
      "Implemented exposure therapy techniques to help the client confront and manage their anxiety triggers. Assisted the client in developing effective coping skills to reduce anxiety symptoms.",
  },
  {
    date: "Feb 15, 2024",
    diagnosis: "Bipolar Disorder Type I (F3100)",
    notes:
      "Provided psychoeducation on bipolar disorder, including mood tracking and symptom management. Collaborated with the client's psychiatrist to adjust medication regimen for mood stabilization.",
  },
  {
    date: "Nov 20, 2024",
    diagnosis: "Schizophrenia (F2000)",
    notes:
      "Implemented a multi-modal treatment approach, including medication management, individual therapy, and psychoeducation for the client and their family. Assisted the client in developing coping strategies for managing symptoms.",
  },
  {
    date: "Dec 7, 2024",
    diagnosis: "Obsessive-Compulsive Disorder (OCD) (F4200)",
    notes:
      "Conducted exposure and response prevention (ERP) therapy to help the client confront and manage their OCD symptoms. Collaborated with the client to develop healthy coping mechanisms for managing obsessive thoughts and compulsive behaviors.",
  },
  {
    date: "Jan 23, 2023",
    diagnosis: "Geriatric Anxiety unspecified (F4320)",
    notes:
      "Provided a safe and supportive environment for the client to share their feelings and experiences openly. Validated their emotions and concerns to create a strong therapeutic alliance.",
  },
  {
    date: "Mar 12, 2023",
    diagnosis: "Geriatric Depression unspecified (F3310)",
    notes:
      "Implemented cognitive-behavioral therapy techniques to challenge negative thought patterns and improve mood. Collaborated with the client to develop coping strategies for managing depressive symptoms.",
  },
  {
    date: "Jun 15, 2023",
    diagnosis: "Adjustment Disorder with Anxiety (F4321)",
    notes:
      "Utilized mindfulness-based techniques to help the client identify and manage triggers for anxiety. Provided psychoeducation on stress management and relaxation techniques.",
  },
  {
    date: "Aug 1, 2023",
    diagnosis: "Post-Traumatic Stress Disorder (PTSD) (F4311)",
    notes:
      "Implemented trauma-focused cognitive-behavioral therapy to address and process past traumatic experiences. Assisted the client in developing healthy coping mechanisms for managing PTSD symptoms.",
  },
  {
    date: "Oct 5, 2023",
    diagnosis: "Major Depressive Disorder (F3200)",
    notes:
      "Conducted a comprehensive assessment to identify the severity and duration of depressive symptoms. Collaborated with the client to develop a personalized treatment plan, including medication and therapy.",
  },
  {
    date: "Jan 30, 2024",
    diagnosis: "Generalized Anxiety Disorder (F4110)",
    notes:
      "Implemented exposure therapy techniques to help the client confront and manage their anxiety triggers. Assisted the client in developing effective coping skills to reduce anxiety symptoms.",
  },
  {
    date: "Feb 15, 2024",
    diagnosis: "Bipolar Disorder Type I (F3100)",
    notes:
      "Provided psychoeducation on bipolar disorder, including mood tracking and symptom management. Collaborated with the client's psychiatrist to adjust medication regimen for mood stabilization.",
  },
  {
    date: "Nov 20, 2024",
    diagnosis: "Schizophrenia (F2000)",
    notes:
      "Implemented a multi-modal treatment approach, including medication management, individual therapy, and psychoeducation for the client and their family. Assisted the client in developing coping strategies for managing symptoms.",
  },
  {
    date: "Dec 7, 2024",
    diagnosis: "Obsessive-Compulsive Disorder (OCD) (F4200)",
    notes:
      "Conducted exposure and response prevention (ERP) therapy to help the client confront and manage their OCD symptoms. Collaborated with the client to develop healthy coping mechanisms for managing obsessive thoughts and compulsive behaviors.",
  },
  {
    date: "Jan 23, 2023",
    diagnosis: "Geriatric Anxiety unspecified (F4320)",
    notes:
      "Provided a safe and supportive environment for the client to share their feelings and experiences openly. Validated their emotions and concerns to create a strong therapeutic alliance.",
  },
  {
    date: "Mar 12, 2023",
    diagnosis: "Geriatric Depression unspecified (F3310)",
    notes:
      "Implemented cognitive-behavioral therapy techniques to challenge negative thought patterns and improve mood. Collaborated with the client to develop coping strategies for managing depressive symptoms.",
  },
  {
    date: "Jun 15, 2023",
    diagnosis: "Adjustment Disorder with Anxiety (F4321)",
    notes:
      "Utilized mindfulness-based techniques to help the client identify and manage triggers for anxiety. Provided psychoeducation on stress management and relaxation techniques.",
  },
  {
    date: "Aug 1, 2023",
    diagnosis: "Post-Traumatic Stress Disorder (PTSD) (F4311)",
    notes:
      "Implemented trauma-focused cognitive-behavioral therapy to address and process past traumatic experiences. Assisted the client in developing healthy coping mechanisms for managing PTSD symptoms.",
  },
  {
    date: "Oct 5, 2023",
    diagnosis: "Major Depressive Disorder (F3200)",
    notes:
      "Conducted a comprehensive assessment to identify the severity and duration of depressive symptoms. Collaborated with the client to develop a personalized treatment plan, including medication and therapy.",
  },
  {
    date: "Jan 30, 2024",
    diagnosis: "Generalized Anxiety Disorder (F4110)",
    notes:
      "Implemented exposure therapy techniques to help the client confront and manage their anxiety triggers. Assisted the client in developing effective coping skills to reduce anxiety symptoms.",
  },
  {
    date: "Feb 15, 2024",
    diagnosis: "Bipolar Disorder Type I (F3100)",
    notes:
      "Provided psychoeducation on bipolar disorder, including mood tracking and symptom management. Collaborated with the client's psychiatrist to adjust medication regimen for mood stabilization.",
  },
  {
    date: "Nov 20, 2024",
    diagnosis: "Schizophrenia (F2000)",
    notes:
      "Implemented a multi-modal treatment approach, including medication management, individual therapy, and psychoeducation for the client and their family. Assisted the client in developing coping strategies for managing symptoms.",
  },
  {
    date: "Dec 7, 2024",
    diagnosis: "Obsessive-Compulsive Disorder (OCD) (F4200)",
    notes:
      "Conducted exposure and response prevention (ERP) therapy to help the client confront and manage their OCD symptoms. Collaborated with the client to develop healthy coping mechanisms for managing obsessive thoughts and compulsive behaviors.",
  },
  {
    date: "Jan 23, 2023",
    diagnosis: "Geriatric Anxiety unspecified (F4320)",
    notes:
      "Provided a safe and supportive environment for the client to share their feelings and experiences openly. Validated their emotions and concerns to create a strong therapeutic alliance.",
  },
  {
    date: "Mar 12, 2023",
    diagnosis: "Geriatric Depression unspecified (F3310)",
    notes:
      "Implemented cognitive-behavioral therapy techniques to challenge negative thought patterns and improve mood. Collaborated with the client to develop coping strategies for managing depressive symptoms.",
  },
  {
    date: "Jun 15, 2023",
    diagnosis: "Adjustment Disorder with Anxiety (F4321)",
    notes:
      "Utilized mindfulness-based techniques to help the client identify and manage triggers for anxiety. Provided psychoeducation on stress management and relaxation techniques.",
  },
  {
    date: "Aug 1, 2023",
    diagnosis: "Post-Traumatic Stress Disorder (PTSD) (F4311)",
    notes:
      "Implemented trauma-focused cognitive-behavioral therapy to address and process past traumatic experiences. Assisted the client in developing healthy coping mechanisms for managing PTSD symptoms.",
  },
  {
    date: "Oct 5, 2023",
    diagnosis: "Major Depressive Disorder (F3200)",
    notes:
      "Conducted a comprehensive assessment to identify the severity and duration of depressive symptoms. Collaborated with the client to develop a personalized treatment plan, including medication and therapy.",
  },
  {
    date: "Jan 30, 2024",
    diagnosis: "Generalized Anxiety Disorder (F4110)",
    notes:
      "Implemented exposure therapy techniques to help the client confront and manage their anxiety triggers. Assisted the client in developing effective coping skills to reduce anxiety symptoms.",
  },
  {
    date: "Feb 15, 2024",
    diagnosis: "Bipolar Disorder Type I (F3100)",
    notes:
      "Provided psychoeducation on bipolar disorder, including mood tracking and symptom management. Collaborated with the client's psychiatrist to adjust medication regimen for mood stabilization.",
  },
  {
    date: "Nov 20, 2024",
    diagnosis: "Schizophrenia (F2000)",
    notes:
      "Implemented a multi-modal treatment approach, including medication management, individual therapy, and psychoeducation for the client and their family. Assisted the client in developing coping strategies for managing symptoms.",
  },
  {
    date: "Dec 7, 2024",
    diagnosis: "Obsessive-Compulsive Disorder (OCD) (F4200)",
    notes:
      "Conducted exposure and response prevention (ERP) therapy to help the client confront and manage their OCD symptoms. Collaborated with the client to develop healthy coping mechanisms for managing obsessive thoughts and compulsive behaviors.",
  },
];

export const dummyChatConversation = [
  {
    type: "incoming",
    message_type: "text",
    name: "Kathryn Murphy",
    message: "Hello Dr Joshua",
    timestamp: "April 24, 2023 - 12:04 AM",
  },
  {
    type: "incoming",
    message_type: "text",
    name: "Kathryn Murphy",
    message: "I had a bad day",
    timestamp: "April 24, 2023 - 12:24 AM",
  },
  {
    type: "outgoing",
    message_type: "text",
    name: "Dr Joshua Abraham",
    message: "Hello Kathryn",
    timestamp: "April 24, 2023 - 12:24 AM",
  },
  {
    type: "outgoing",
    message_type: "text",
    name: "Dr Joshua Abraham",
    message: "Hi, tell me more",
    timestamp: "April 24, 2023 - 12:24 AM",
  },
  {
    type: "incoming",
    message_type: "text",
    name: "Kathryn Murphy",
    message: "Hello Dr Joshua",
    timestamp: "April 24, 2023 - 12:04 AM",
  },
  {
    type: "incoming",
    message_type: "text",
    name: "Kathryn Murphy",
    message: "I had a bad day",
    timestamp: "April 24, 2023 - 12:24 AM",
  },
  {
    type: "outgoing",
    message_type: "text",
    name: "Dr Joshua Abraham",
    message: "Hello Kathryn",
    timestamp: "April 24, 2023 - 12:24 AM",
  },
  {
    type: "outgoing",
    message_type: "text",
    name: "Dr Joshua Abraham",
    message: "Hi, tell me more",
    timestamp: "April 24, 2023 - 12:24 AM",
  },
];

export const ProviderFAQ = [
  {
    id: 1,
    heading: "Registration / Onboarding",
    data: [
      {
        title: "What is Rose?",
        text: `The Rose App is a patient-facing application that allows patients to take assigned assessments, log their moods, journal, and access relevant content suggested by Rose and assigned by their provider. Using a provider-facing, web-based dashboard, Rose synthesizes the patient entered data into a patient summary that is monitored by the Rose Care Team or the patient's care team. Rose allows you to get key insights on your patients in between visits, and the remote monitoring provides a solution that enables early intervention to improve patient outcomes.`,
      },
      {
        title: "How can Rose help me in my practice?",
        text: "Rose allows you to monitor and connect with patients in-between visits. The time you and your patients use on the platform can be eligible for BHI (Behavioral Health Integration) and/or CoCM (Collaborative Care)  reimbursements. This data also allows you to review your patient’s progress before each session informing you of key items to cover in your in-person or telemedicine visits.",
      },
      {
        title: "What are the CPT codes for BHI and CoCM?",
        text: `BHI 99484<br/>
        CoCM codes: 99492, 99493`,
      },
      {
        title: "Do we bill these codes or does Rose do it for us?",
        text: "Typically someone from your current billing team will bill these codes.  We do have an RCM team if you need billing assistance.",
      },
      {
        title: "How does Rose help my patients?",
        text: "Research has shown that patients show significant improvement in mood and anxiety when they engage in self-care between visits. The Rose Health app is available to all of your patients. The app provides psychoeducation to your patients, ways to increase their self awareness and scientifically proven approaches to alleviate the burden of stress on the body and improve their resilience. ",
      },
      {
        title: "How does Rose Work?",
        text: "Rose provides both a patient-facing app and a clinician-facing dashboard. The patient will engage with the app by completing standardized assessments, daily check-ins, journaling and reading, and listening to and engaging with content that increases their knowledge of themselves and their symptoms. Through the app, patients could have access to a care team to provide coaching, crisis management, and connection to a long-term therapist. Our AI technology will triage the patients back to the clinician dashboard and organize them in a way that allows the dashboard monitor to know which patients are at risk and what level of risk that patient is experiencing. Clinicians can utilize this information to augment their treatment, add value and improve outcomes.",
      },
      {
        title: "Let's get started",
        text: "Once you sign up for Rose you will receive a welcome email with a link for you to create a username and password. Upon logging in, you will be guided through a 5 minute tutorial of Rose, highlighting the main features of the platform. Next, you will begin inviting patients using your unique provider code. You can invite patients by emailing them directly from the platform and can track when they have downloaded and created an account.",
      },
    ],
  },

  {
    id: 2,
    heading: "Patient Experience",
    data: [
      {
        title: "How do my patients sign-up?",
        text: `Patients can sign up for the app in several ways. 
        <div class="container mt-2">
        ●	To invite patients through the provider dashboard: Once logged into your clinician dashboard, you'll see a button to "invite" on the right hand side. Add in your patient's name, mobile phone number and email into the designated areas and your patient will receive an invite via text message or email.  
        <br/>
        ●	To add patients in bulk: Use the template provided. When you do this, Rose will send your patient a link to download the app. 
        <br/>
        ●	To prompt your patient to download the app and sign up on their own: Patient will search for “Rose: Smarter Mental Health” on their respective App store. You will need to provide the 4 digit provider code at the top left of your dashboard. Once they have downloaded the app, they will enter your unique 4-digit code to connect to you.
        </div>
        `,
      },
      {
        title: "What should my patient expect?",
        text: "Upon downloading the app and creating an account, patients will be prompted to take and initial PHQ-9 depression screening and GAD-7 anxiety screening. They will tap through a brief introduction to Rose. The patient and provider should have a discussion of expectations forof using the Rose App. In order for the most successful experience we recommend the patient log their mood and journal at least a few times each week. The best results come from using the app to check in with themselves and create a log of their moods daily.",
      },
      {
        title: "How does Rose help my patients?",
        text: "Rose helps patients report the specifics of their mental health experience. This opportunity provides patients with a feeling of being heard and seen. The user-friendly platform guides your patients in reporting their symptoms in a way that helps them build connections between their physical status and mental health. Rose provides scientifically proven techniques to decrease negative symptoms in between appointments and provides your patients with a resource that you can trust as they navigate their mental health outside of your office. Rose also increases your ability to accurately assess and treat your patients for the best outcomes.",
      },
      {
        title:
          "Do I have to teach my patients how to use the Rose App or does Rose provide an overview to my patients?",
        text: `Rose will guide new patient users on how to use the app, and the app is designed to be intuitive and accessible. However, the most successful patients are ones who are encouraged by their physicians and care team. Please advise patients to keep their phone notifications turned on so they can get reminders, tips, and coaching. `,
      },
    ],
  },
  {
    id: 3,
    heading: "Privacy & Liability",
    data: [
      {
        title:
          "How is the privacy of my patients and my practice protected within Rose?",
        text: `Rose is HIPAA-compliant both on the provider dashboard and patient app. All information is saved safely and securely in our AWS cloud services.`,
      },
      {
        title:
          "Are patients notified when their provider views their mood logs or journal?",
        text: "No, patients will not know when their provider has reviewed their Rose profile, including journals, messages, and assessments. We do encourage physicians to let their patients know that their inputs can be viewed by the provider.",
      },
      {
        title: "How does Rose address liability concerns?",
        text: "With guidance from our medical malpractice insurer, we have disclaimers built into the onboarding process to address liability concerns. Throughout the app, there are strategically placed reminders that the platform is not monitored 24/7 and that there are avenues to reach out for additional crisis support services. Further, we have arguably the best cyber and virtual care insurance which provides insurance coverage per case of any incident. While liability is inherent in all forms of care delivery, we have designed our disclaimers and insurance to meet or exceed standard of care practices.",
      },
    ],
  },
  {
    id: 4,
    heading: "Billing",
    data: [
      {
        title: "How do I pay for my subscription?",
        text: "Subscriptions are billed monthly via a credit card you put on file. You can contact us for additional information or help entering your credit card information.",
      },
      {
        title: "I have questions about my subscription, who can I talk to?",
        text: `Please reach out to <a href="mailto:help@rosehealth.com">help@rosehealth.com</a> for more information.`,
      },
      {
        title: "What is BHI?",
        text: `BHI stands for Behavioral Health Integration. It is a type of care management service. In recent years, CMS updated the Medicare Physician Fee Schedule (MPFS) policies to improve payment for care management services. New codes describe services that work with or on behalf of the patient to address behavioral health needs, concerns and treatment. Learn more <a href="https://www.cms.gov/Outreach-and-Education/Medicare-Learning-Network-MLN/MLNProducts/Downloads/BehavioralHealthIntegration.pdf" target="_blank" rel="noopener noreferrer">Here</a>.`,
      },
      {
        title: "How can I bill for BHI?",
        text: `CPT code 99484 is used to bill monthly services delivered using BHI models. Behavioral health care management needs to be at least 20 minutes of clinical staff time. This 20 minutes can be performed by the physician or another staff member and includes viewing the dashboard, communicating with our BH specialist, sending content to the patient, care planning etc. Rose can support your billing team in billing BHI or we can do it for you.`,
      },
      {
        title: "When is a patient eligible for BHI?",
        text: "Our AI triages someone as eligible for BHI when they score a 10 or higher on the PHQ8 or GAD7. However, if a patient has a history of depression, anxiety, other behavioral health concerns or a comorbidity that is often associated with a behavioral health condition, you can change the “flag” in the patient chart to yellow or red and this will make them eligible for BHI. We recommend you document this change in the notes section.",
      },
      {
        title: "What is CoCM?",
        text: `The Psychiatric Collaborative Care Model (CoCM) is a more in depth approach to integrating behavioral health into your practice. Think of it as the next level of BHI. It is considered to be the most effective evidence-based integrated care model for behavioral health, validated by more than 90 randomized controlled trials. CoCM encourages a holistic team-based approach to treating common mental health conditions by integrating behavioral health professionals into the care team. These behavioral health professionals provide support to the other care team members on things such as medication management and treatment planning. CoCM is very effective yet it often comes at a high cost and physician practices don't know where to start. Rose combines technology with our team of experts to make starting a CoCM model easier and more efficient to drive successful outcomes for both the patient and the practice.
        <div class="container-fluid my-4 w-100 text-center">
        <img src="https://genericrosebucket.s3.amazonaws.com/images/CoCM+Diagram.png" class="img-fluid" alt="Diagram for CoCM" /></div>`,
      },
      {
        title: "How do I bill for CoCM?",
        text: `
        CPT codes 99492, 99493, and 99494 are used to bill monthly services delivered using CoCM models. Collaborative care management needs to be at least 70 minutes of clinical staff time for the first month, 60 mins for following months and an add on code for 30 minutes for any month. This 70 minutes can be performed by the physician or another staff member and includes:
          <div class="container my-2">
          ●	assessing treatment adherence, tolerability, and clinical response by monitoring rating scales on clinician dashboard
          <br/>
          ●	pinning relevant evidence-based psychoeducational content
          <br/>
          ●	engaging in coaching interventions such as behavioral activation or motivational interviewing
          <br/>
          ●	regular caseload review with psychiatric consultant
          <br/>
          ●	reviewing the patient's treatment plan and status with the psychiatric consultant
          <br/>
          ●	referral to behavioral health specialty care, as needed. 
          <br/>
          </div>
        Rose can support your billing team in billing CoCM or we can do it for you.
        `,
      },
    ],
  },
  {
    id: 5,
    heading: "Provider-facing Dashboard",
    data: [
      {
        title: "Where do I find my unique PIN code?",
        text: "On the clinician dashboard, in the upper left corner you will see your 4-digit pin, which is also used as the verification code for the patient.",
      },
      {
        title: "Can I print out a general report on each patient?",
        text: `
        Yes, to download a pdf summary to upload into your EMR
        <div class="container mt-2">
          ●	Login into your Rose Provider account.
          <br/>
          ●	Select the patient and scroll to the date section and enter the date range of data you would like to appear on the patient summary pdf report.  
          <br/>
          ●	Click on the “Download” button at the top of the screen and a pdf patient summary will be downloaded to your computer.
        </div>
        `,
      },
      {
        title:
          "Can I change the frequency & when my patients are scheduled to take the assessments?",
        text: "Yes, click on each patient's clinical profile on the Rose dashboard. From the dashboard, click on assessments and edit the next date the assessment will be administered.",
      },
      {
        title: "Can Rose integrate with my EMR?",
        text: `Yes it is possible for Rose to integrate into your EMR.  There are varying levels of integration. You can import all the Rose reports as PDF into your EMR.`,
      },
      {
        title:
          "How is the content for Rose curated? What insights does it provide for patients?",
        text: "Our content is created by our in-house team of writers, wellness experts and mental health specialists as well as key partnerships with external organizations.  Our content is curated based on the patient's interaction with the app.",
      },
      {
        title:
          "What is the Rose Paths module and how does it benefit my patients?",
        text: "Rose Paths are organized content modules that walk your patient through curated content. This allows for an organized review of recommended content based on symptoms (e.g., anxiety, depression, trauma)",
      },
      {
        title:
          "How will the dashboard determine which patients are eligible to participate in Behavioral Health Integration (BHI)?",
        text: `
        You will see a tab for BHI eligible patients on your home screen.  Rose uses a strict method of qualifying patients for BHI.  In order to be eligible, patients must have completed at least one assessment that month and they must have scored above a 5 on their depression or anxiety screening.  These patients will automatically populate on your billing dashboard (separate page with a separate login).  You can override this and enroll the patient if the clinician wants to watch the patient due to history or other concerns.  You can do this by resetting their flag in the patient chart.
        `,
      },
      {
        title: "Can we send specific content to the patient?",
        text: `
        Yes. You will see a tab in the patient chart called “pin content.”  From there you will see articles, videos and audio clips that you can preview and “pin” to your patient.  The patient will receive a notification that you have suggested content for them and our surveys have shown that patients love to get suggestions from their care team. This is a great way to engage your patient and empower them to take charge of their mental wellbeing.
        `,
      },
      {
        title: "Do I have to use the chat feature?",
        text: `
        No, you can disable the chat feature in the patient chart. If you choose to disable this feature, your patient will not see a “chat” button on their app.
        `,
      },
    ],
  },

  {
    id: 6,
    heading: "Technical Troubleshooting",
    data: [
      {
        title: "How do I change my password?",
        text: `To change your password, you can login and click on the 'Settings' tab. From 'Settings' you will be able to change your email address and password on the far right of the screen. Clicking 'Change' will apply the changes.`,
      },
      {
        title:
          "What is the turn-around time if I bring an issue to the Rose team?",
        text: `We do our best to get back to you as soon as possible and you can expect to hear from us within 24 - 48 hours via phone or email.`,
      },
      {
        title:
          "I'd like to report a problem with the app and/or clinical dashboard. Who do I contact?",
        text: `Please contact Rose for any assistance with the platform by emailing us at <a href="mailto:help@rosehealth.com">help@rosehealth.com</a> or calling <a href="tel:(833) 400-7673">(833) 400-7673</a>.`,
      },
      {
        title: "Can Rose integrate with my EMR?",
        text: "You can import all the Rose reports as PDF into your EMR. Our team is also available to help implement higher levels of integration with your EMR.",
      },
    ],
  },
];

export const PatientFAQ = [
  {
    id: 1,
    heading: "General FAQs",
    data: [
      {
        title: "What is Rose?",
        text: `Rose is a mental health application that keeps you and your provider all on the same page regarding your day to day mental health functioning. The app provides an easy way to track your mood, journal, and learn relevant information assigned by their provider about how you can be the best version of yourself. You'll have your progress all in one place, along with encouragement and guidance to practice scientifically backed techniques to further improve your mental health. Your provider will have access to all of the information you put in your app and will be able to provide a higher level of care.`,
      },
      {
        title: "How does Rose help me?",
        text: "Rose helps you to take part in your mental health care journey by providing a user-friendly platform, informing you about scientifically proven small changes that make a big impact and providing a big picture reflection of your progress overtime. Rose also strengthens the rapport between you and your provider because the more Rose learns about you the better your provider will have an authentic clinical picture to provide a higher level of quality care focused mental growth.",
      },
      {
        title: "What is the PIN number?",
        text: `A unique Pin number is given by providers to their patients in order to connect your mobile app account to their provider dashboard. If you need help finding your pin number, please call your provider.`,
      },
      {
        title: "What are the key features that I can use within the Rose App?",
        text: `The key features of Rose are:
          <div class="container mt-2">
          ●	Mood tracking & Journaling to increase self-awareness of you mental health & to communicate to your provider directly 
          <br/>
          ●	Insights from their recent mood assessments 
          <br/>
          ●	Access to relevant articles, video and audio clips 
          <br/>
          ●	Ability to track talking points for upcoming sessions within your journal
          <br/>
          ●	Access to National Help hotlines to speak to someone immediately.
          <br/>
          ●	Live Motivational Coaching (not available to all users, as your provider)
          </div>`,
      },
      {
        title:
          "What does my provider have access to? (ex. Can they see my journal?)",
        text: "Your provider can see your journal and can use these to prepare for your next session. Additionally, they will get summary data on your mood, assessments, and common themes from your journal entries.",
      },
      {
        title: "How is my privacy protected?",
        text: "Rose is HIPAA-compliant both on the provider dashboard and patient app. All information is saved safely and securely in our AWS cloud services.",
      },
    ],
  },
];
